import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import {
   Grid,
   GridItem,
   useColorModeValue,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   Stepper,
   Step,
   StepIndicator,
   StepStatus,
   StepIcon,
   StepNumber,
   StepTitle,
   StepDescription,
   StepSeparator,
   Heading,
   Box,
   FormControl,
   FormLabel,
   Text,
   Input,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';

import { renderFormControl, renderSelectFormControl } from 'utils/DynamicFormData';
import { getItemGroup } from '../../../../../redux/actions/itemGroup';
import { getHsn } from '../../../../../redux/actions/hsn';
import { getUnit } from '../../../../../redux/actions/uqc';
import { BROKERAGE_TYPES, ITEM_TYPES, ITEM_DETAILS_TYPES } from '../../variables/types';
import { renderSwitchControl } from 'utils/DynamicFormData';
import { getVendors } from '../../../../../redux/actions/vendor';
import {
   addItem,
   updateItem,
   getItemForMaster,
   getItem,
   getItems,
   getItemByFinishItem,
} from '../../../../../redux/actions/item';
import { ACTION_TYPE } from '../../../../../variables/company';
// import { getCompanies } from '../../../../../redux/actions/company';
import { getCategory } from '../../../../../redux/actions/category';
import { useBusinessType } from '../../../../../contexts/BusinessType';
import { getSeries } from '../../../../../redux/actions/series';
import { getColor } from '../../../../../redux/actions/color';
import { RAM_TYPE, STORAGE_TYPE, NETWORK_TYPE } from '../../../../../variables/company';
import { ACCOUNT_TYPE } from '../../../../../constants/index';
import '../../../companyProfile/css.css';
import { useUser } from '../../../../../contexts/UserContext';
import { removeDuplicates, getDefaultId, getShareCompanyOptions } from '../../../../../utils/util';
import { DynamicInput } from '../../../../../components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from '../../../../../components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from '../../../../../components/ui/DynamicDropdown';
import { useGlobal } from '../../../../../contexts';
import Loading from 'components/loading/Loading';
import { extractModelName } from 'utils/util';
import { getMainAndSubHsn } from '../../../../../redux/actions/mainAndSubHsn';

const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),

   // barcode: Yup.string()
   //   .required('Barcode is required')
   //   .min(3, 'Barcode must be at least 3 characters long'),

   uqcid1: Yup.number().required('Unit 1 is required').min(1, 'Unit 1 must be at least 1'),

   uqcid2: Yup.string().required('Unit 2 is required'),
   // .test(
   //   'unique-unit',
   //   'Units must be different',
   //   function (value) {
   //     const { uqcid1, uqcid3 } = this.parent;
   //     if (!value) return true; // Allow empty value
   //     return value !== uqcid1 && value !== uqcid3;
   //   },
   // ),
   uqcid3: Yup.string().required('Unit 3 is required'),
   //   .test(
   //     'unique-unit',
   //     'Units must be different',
   //     function (value) {
   //     const { uqcid1, uqcid2 } = this.parent;
   //     if (!value) return true; // Allow empty value
   //     return value !== uqcid1 && value !== uqcid2;
   //   },
   // ),
   ratepersalesid: Yup.string().required('Rate Per Sales is required'),
   // .test(
   //   'unique-rate',
   //   'Sales, Purchase, and Primary UQC rates must be different',
   //   function (value) {
   //     const { rateperpurchaseid, primaryuqcid } = this.parent;
   //     if (!value || (!rateperpurchaseid && !primaryuqcid)) return true;
   //     return value !== rateperpurchaseid && value !== primaryuqcid;
   //   },
   // ),

   rateperpurchaseid: Yup.string().required('Rate Per Purchase is required'),
   //   .test(
   //     'unique-rate',
   //     'Sales, Purchase, and Primary UQC rates must be different',
   //     function (value) {
   //     const { ratepersalesid, primaryuqcid } = this.parent;
   //     if (!value || (!ratepersalesid && !primaryuqcid)) return true;
   //     return value !== ratepersalesid && value !== primaryuqcid;
   //   },
   // ),

   primaryuqcid: Yup.string().required('Primary UQC is required'),
   //   .test(
   //     'unique-rate',
   //     'Sales, Purchase, and Primary UQC rates must be different',
   //     function (value) {
   //     const { ratepersalesid, rateperpurchaseid } = this.parent;
   //     if (!value || (!ratepersalesid && !rateperpurchaseid)) return true;
   //     return value !== ratepersalesid && value !== rateperpurchaseid;
   //   },
   // ),

   // ratepersalesid: Yup.string()
   // .required('Rate Per Sales is required')
   // .test('unique-rate', 'Sales and Purchase rates must be different', function(value) {
   //   const { rateperpurchaseid } = this.parent;
   //   if (!value || !rateperpurchaseid) return true;
   //   return value !== rateperpurchaseid;
   // }),
   // rateperpurchaseid: Yup.string()
   // .test('unique-rate', 'Sales and Purchase rates must be different', function(value) {
   //   const { ratepersalesid } = this.parent;
   //   if (!value || !ratepersalesid) return true;
   //   return value !== ratepersalesid;
   // }),

   // rateperpurchaseid: Yup.string()
   //   .required('Rate Per Purchase is required')
   //   .test('unique-rate', 'Sales and Purchase rates must be different', function(value) {
   //     const { ratepersalesid } = this.parent;
   //     if (!value || !ratepersalesid) return true;
   //     return value !== ratepersalesid;
   //   })

   // hsnId: Yup.number()
   //   .required('HSN is required')
   //   .min(1, 'HSN must be at least 1')
   //   .typeError('HSN must be a number'),

   // ratepersalesid: Yup.number()
   //   .required('Rate Per Sales ID is required')
   //   .min(1, 'Rate Per Sales ID must be at least 1')
   //   .typeError('Rate Per Sales ID must be a number'),

   // rateperpurchaseid: Yup.number()
   //   .required('Rate Per Purchase ID is required')
   //   .min(1, 'Rate Per Purchase ID must be at least 1')
   //   .typeError('Rate Per Purchase ID must be a number'),
});

const steps = [
   {
      step: 0,
      title: 'Basic',
      description: 'Enter Basic Here',
   },
   {
      step: 1,
      title: 'Purchase/Sales Info.',
      description: 'Enter Order/Challan Setting Here',
   },
   {
      step: 2,
      title: 'Inventory Info.',
      description: 'Enter Item Setting Here',
   },
   {
      step: 3,
      title: 'Others',
      description: 'Enter Credit Limit Setting Here',
   },
];

const ItemMasterForm = ({
   isOpen,
   onClose,
   isEditMode = false,
   demoname,
   currentRow = null,
   onSave,
   saveandcontinue = true,
   currentPage,
   limit,
   searchQuery,
   sorting,
   pagination,
   isAbs = false,
}) => {
   const [activeStep, setActiveStep] = useState(0);
   const [errors, setErrors] = useState({});
   const [ratePerSalesOptions, setRatePerSalesOptions] = useState([]);
   // const [company, setCompany] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const [isLoadingbt, setIsLoadingbt] = useState(false);
   const [dataFetched, setDataFetched] = useState(false);
   const { businessTypes } = useBusinessType();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const { user } = useUser();
   const { companyList, company, userGlobalSettingsData } = useGlobal();
   const applyGST = company?.setting?.applyGST;

   const shouldSendCompanyidItemGroup = userGlobalSettingsData?.[0]?.askCompany?.itemGroup || false;
   const shouldSendCompanyidCategory = userGlobalSettingsData?.[0]?.askCompany?.category || false;
   const shouldSendCompanyidAccount = userGlobalSettingsData?.[0]?.askCompany?.account || false;
   const shouldSendCompanyidColor = userGlobalSettingsData?.[0]?.askCompany?.color || false;
   const shouldSendCompanyidSeries = userGlobalSettingsData?.[0]?.askCompany?.series || false;
   const shouldSendCompanyidItem = userGlobalSettingsData?.[0]?.askCompany?.item || false;

   const toast = useToast();
   const dispatch = useDispatch();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const itemGroupData = useSelector((state) => state.itemGroup.list);
   const categoryData = useSelector((state) => state.category.list || []);
   const allHsnData = useSelector((state) => state.mainAndSubHsn.list);
   const hsnData = allHsnData.filter((record) => record.gstType === 'G');
   const sacData = allHsnData.filter((record) => record.gstType === 'S');
   const uqc = useSelector((state) => state.uqc.list);
   const vendorData = useSelector((state) => state.vendor.list);
   const itemData = useSelector((state) => state.item.list);
   const finishItemData = useSelector((state) => state.item.finishItem);
   // const companyData = useSelector((state) => state.company.list);
   const seriesData = useSelector((state) => state.series.list);
   const colorData = useSelector((state) => state.color.list);

   const businessType = localStorage.getItem('businessTypes');
   const mobile = businessType === 'MOBILE';
   const Textile = businessType === 'TEXTILE';

   const [row, setRow] = useState({
      code: '',
      itemtype: 0,
      categoryid: null,
      itemdetailtype: company?.setting?.itemDetailType,
      isassembly: false,
      itemgroupid: company?.setting?.itemGroupId,
      parentid: 0,
      name: '',
      shortname: '',
      aliasname: '',
      printname: '',
      purchaseprice: 0,
      purchasecostper: 1,
      purchasebrokeragetype: 0, // 0 = NONE, 1 = PERCENTAGE, 2 = QUANTITY
      purchasebrokerage: 0,
      vendorid: 0,
      companyIds: [],
      stockrate: 0,
      wholesalerate: 0,
      salesprice1: 0,
      salesprice2: 0,
      salesprice3: 0,
      minsalesprice: 0,
      maxsalesprice: 0,
      actiononminmaxprice: 0,
      defaultsellingqty: 1,
      salespriceper: 0,
      salesbrokeragetype: 0,
      salesbrokerage: 0,

      uqcid1: company?.setting?.UOM1,
      uqcformat1: 0,
      packing12: 0,
      packingname12: '',
      packing13: 0,
      packingname13: '',
      defaultquantity1: 0,
      openingStock1: 0,

      uqcid2: company?.setting?.UOM2,
      uqcformat2: 0,
      packing23: 0,
      packingname23: '',
      packing21: 0,
      packingname21: '',
      defaultquantity2: 0,
      openingStock2: 0,

      uqcid3: company?.setting?.UOM3,
      uqcformat3: 0,
      packing31: 0,
      packingname31: '',
      packing32: 0,
      packingname32: '',
      defaultquantity3: 0,
      openingStock3: 0,

      primaryuqcid: 0,
      ratepersalesid: 0,
      rateperpurchaseid: 0,
      weight: 0,
      length: 0,
      width: 0,
      height: 0,
      minlevel: 0,
      warnbelowminlvl: 0,
      maxlevel: 0,
      warnabovemaxlvl: 0,
      reorderlevel: 0,
      reorderquantity: 0,
      warnbelowreorder: 0,
      stocknegativeaction: 0,
      defaultcut: 0,
      calculatemts: false,
      // balancequantity1: 0,
      // balancequantity2: 0,
      // balancequantity3: 0,
      foldpercentage: 0,
      image: null,
      notes: '',
      nameinotherlanguage: '',
      additioninsalesprice: 0,
      hsnid: 0,
      sacid: 0,
      saleDiscPer: 0,
      saleDiscAmt: 0,
      purchaseDiscPer: 0,
      purchaseDisAmt: 0,
      finishItemId: 0,

      // Mobile Details
      seriesId: null,
      mrp: 0,
      colorId: null,
      ram: null,
      storage: null,
      cellular: false,
      gst: false,
      order: 0,
      network: null,
      battery: 0,
      display: '',
      displayType: '',
      frontCamera: '',
      rearCamera: '',
      processor: '',
      mmSize: '',
   });

   const checkDataLoaded = useCallback(() => {
      if (isLoading && dataFetched) {
         // For basic data that's always needed
         const basicDataLoaded = itemGroupData != null && allHsnData != null && uqc != null && vendorData != null;

         // For mobile-specific data that's only needed for mobile business type
         const mobileDataNeeded = businessTypes?.businessType === 'MOBILE';
         const mobileDataLoaded = !mobileDataNeeded || (seriesData != null && colorData != null);
         if (basicDataLoaded && mobileDataLoaded) {
            setIsLoading(false);
         }
      }
   }, [itemGroupData, uqc, vendorData, allHsnData, businessTypes, seriesData, colorData, isLoading, dataFetched]);

   const clearFormData = useCallback(() => {
      setRow({
         code: '',
         itemtype: 0,
         categoryid: null,
         itemdetailtype: company?.setting?.itemDetailType,
         isassembly: false,
         itemgroupid: company?.setting?.itemGroupId,
         parentid: 0,
         name: '',
         shortname: '',
         aliasname: '',
         printname: '',
         purchaseprice: 0,
         purchasecostper: 1,
         purchasebrokeragetype: 0, // 0 = NONE, 1 = PERCENTAGE, 2 = QUANTITY
         purchasebrokerage: 0,
         vendorid: 0,
         companyIds: [],
         stockrate: 0,
         wholesalerate: 0,
         salesprice1: 0,
         salesprice2: 0,
         salesprice3: 0,
         minsalesprice: 0,
         maxsalesprice: 0,
         actiononminmaxprice: 0,
         defaultsellingqty: 1,
         salespriceper: 0,
         salesbrokeragetype: 0,
         salesbrokerage: 0,

         uqcid1: company?.setting?.UOM1,
         uqcformat1: 0,
         packing12: 0,
         packingname12: '',
         packing13: 0,
         packingname13: '',
         defaultquantity1: 0,
         openingStock1: 0,

         uqcid2: company?.setting?.UOM2,
         uqcformat2: 0,
         packing23: 0,
         packingname23: '',
         packing21: 0,
         packingname21: '',
         defaultquantity2: 0,
         openingStock2: 0,

         uqcid3: company?.setting?.UOM3,
         uqcformat3: 0,
         packing31: 0,
         packingname31: '',
         packing32: 0,
         packingname32: '',
         defaultquantity3: 0,
         openingStock3: 0,

         primaryuqcid: company.setting.primaryUnit,
         ratepersalesid: company.setting.maxUOM >= 1 ? company.setting.UOM1 : 0,
         rateperpurchaseid:
            company.setting.maxUOM > 1 && company.setting.maxUOM <= 3
               ? company.setting.UOM2
               : company.setting.maxUOM === 2
               ? company.setting.UOM2
               : company.setting.UOM1,
         weight: 0,
         length: 0,
         width: 0,
         height: 0,
         minlevel: 0,
         warnbelowminlvl: 0,
         maxlevel: 0,
         warnabovemaxlvl: 0,
         reorderlevel: 0,
         reorderquantity: 0,
         warnbelowreorder: 0,
         stocknegativeaction: 0,
         defaultcut: 0,
         calculatemts: false,
         balancequantity1: 0,
         balancequantity2: 0,
         balancequantity3: 0,
         foldpercentage: 0,
         image: '',
         notes: '',
         nameinotherlanguage: '',
         additioninsalesprice: 0,
         hsnid: company.setting.defaultHSN,
         sacid: company.setting.defaultSAC,
         saleDiscPer: 0,
         saleDiscAmt: 0,
         purchaseDiscPer: 0,
         purchaseDisAmt: 0,
         finishItemId: 0,

         seriesId: null,
         mrp: 0,
         colorId: null,
         ram: null,
         storage: null,
         cellular: false,
         gst: false,
         order: 0,
         network: null,
         battery: 0,
         display: '',
         displayType: '',
         frontCamera: '',
         rearCamera: '',
         processor: '',
         mmSize: '',
      });
      setErrors({});
   });

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         // Only set if not in edit mode and companyIds is empty or doesn't include the user's company
         setRow((prev) => {
            if (prev.companyIds.length === 0 || !prev.companyIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  companyIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   const seriesOptions = (Array.isArray(seriesData) ? seriesData : []).map((item) => ({
      ...item,
      label: item?.printName ? item?.printName + ' ' + item.name : item.name,
      value: item.id,
      name: item.name,
      id: item.id,
   }));

   // Get component name by field and value
   const getComponentName = (field, value) => {
      if (!value) return null;

      switch (field) {
         // case 'seriesId':
         //    const series = seriesData.find((s) => s.id === value);
         //    return series ? series.printName + ' ' + series.name : null;
         case 'seriesId':
            const series = seriesData.find((s) => s.id === value);
            return series ? series.name : null; // No more printName

         case 'ram':
            const ram = RAM_TYPE.find((r) => r.id === value);
            return ram ? `${ram.value}GB` : null;

         case 'storage':
            const storage = STORAGE_TYPE.find((s) => s.id === value);
            if (!storage) return null;

            // Format as TB if ≥ 1000GB
            if (storage.value >= 1000) {
               const tbValue = storage.value / 1024;
               return `${tbValue}TB`;
            } else {
               return `${storage.value}GB`;
            }
         case 'colorId':
            const color = colorData.find((c) => c.id === value);
            return color ? color.name : null;

         default:
            return null;
      }
   };

   //with lowercase
   const getCurrentComponentInName = (field, rowData) => {
      const currentName = rowData.name.toUpperCase(); // Convert once

      switch (field) {
         case 'seriesId':
            // Sort series data by name length (longest first) to avoid partial matches
            const sortedSeriesData = [...seriesData].sort((a, b) => b.name.length - a.name.length);

            for (const series of sortedSeriesData) {
               if (currentName.includes(series.name.toUpperCase())) {
                  return series.name; // Return original case
               }
            }
            break;

         case 'colorId':
            for (const color of colorData) {
               if (currentName.includes(color.name.toUpperCase())) {
                  // Return the actual string as it appears in the name
                  const colorIndex = currentName.indexOf(color.name.toUpperCase());
                  if (colorIndex !== -1) {
                     // Extract the color name as it appears in the original text
                     return rowData.name.substring(colorIndex, colorIndex + color.name.length);
                  }
                  return color.name; // Fallback to original color name
               }
            }
            break;

         case 'ram':
            const ramMatches = rowData.name.match(/\b(\d+)\s*GB(\s+RAM)?\b/i);
            if (ramMatches) {
               return ramMatches[0];
            }
            break;

         case 'storage':
            const tbMatch = rowData.name.match(/\b(\d+)\s*TB(\s+Storage)?\b/i);
            if (tbMatch) {
               return tbMatch[0];
            }

            const gbWithStorageMatch = rowData.name.match(/\b(\d+)\s*GB\s+Storage\b/i);
            if (gbWithStorageMatch) {
               return gbWithStorageMatch[0];
            }

            const gbMatches = Array.from(rowData.name.matchAll(/\b(\d+)\s*GB\b/gi));
            if (gbMatches.length > 1) {
               let ramValue = null;
               for (const match of gbMatches) {
                  const value = parseInt(match[1]);
                  if (value <= 24) {
                     ramValue = match[0];
                     break;
                  }
               }

               if (ramValue) {
                  for (const match of gbMatches) {
                     if (match[0] !== ramValue) {
                        return match[0];
                     }
                  }
               }
            }

            const singleGbMatch = rowData.name.match(/\b(\d+)\s*GB\b/i);
            if (singleGbMatch && parseInt(singleGbMatch[1]) > 24) {
               return singleGbMatch[0];
            }
            break;

         default:
            return null;
      }

      return null;
   };

   const updateProductNameFromDropdown = (field, value, rowData) => {
      // If name is empty, generate a new name from all components
      if (!rowData.name || rowData.name.trim() === '') {
         return generateFullProductName(rowData);
      }

      const currentName = rowData.name;
      const newComponentName = getComponentName(field, value);
      // If we can't determine the new component name, return unchanged
      if (!newComponentName) {
         // If value is null/empty, we should remove the component
         if (!value) {
            const currentComponent = getCurrentComponentInName(field, rowData);
            if (currentComponent) {
               return currentName.replace(currentComponent, '').replace(/\s+/g, ' ').trim();
            }
         }
         return currentName;
      }

      // Get the current component in the name
      const currentComponent = getCurrentComponentInName(field, rowData);

      // Handle series replacement specially
      // if (field === 'seriesId') {
      //    // Get the new series
      //    const newSeries = seriesData.find((s) => s.id === value);

      //    // Create the new full series name (printName + name)
      //    const newFullSeriesName =
      //       newSeries && newSeries.printName ? `${newSeries.printName} ${newSeries.name}` : newComponentName;

      //    // First try to identify and remove any existing series names from all series options
      //    let nameWithoutAnySeries = currentName;

      //    // Sort series data by name length (longest first) to avoid partial matches
      //    const sortedSeriesData = [...seriesData].sort((a, b) => b.name.length - a.name.length);

      //    for (const series of sortedSeriesData) {
      //       // Create patterns to match all possible combinations of series name and printName
      //       const seriesName = series.name;
      //       const printName = series.printName;

      //       if (seriesName && nameWithoutAnySeries.includes(seriesName)) {
      //          // First try with printName if available
      //          if (printName) {
      //             // Try different combinations of printName and seriesName
      //             const pattern1 = new RegExp(`${printName}\\s+${seriesName}`, 'i');
      //             const pattern2 = new RegExp(`${seriesName}\\s+${printName}`, 'i');

      //             if (pattern1.test(nameWithoutAnySeries)) {
      //                nameWithoutAnySeries = nameWithoutAnySeries.replace(pattern1, '');
      //             } else if (pattern2.test(nameWithoutAnySeries)) {
      //                nameWithoutAnySeries = nameWithoutAnySeries.replace(pattern2, '');
      //             } else {
      //                // If no pattern matches, just remove the series name
      //                nameWithoutAnySeries = nameWithoutAnySeries.replace(new RegExp(`\\b${seriesName}\\b`, 'i'), '');
      //             }
      //          } else {
      //             // No printName, just remove the series name
      //             nameWithoutAnySeries = nameWithoutAnySeries.replace(new RegExp(`\\b${seriesName}\\b`, 'i'), '');
      //          }

      //          // Clean up extra spaces
      //          nameWithoutAnySeries = nameWithoutAnySeries.replace(/\s+/g, ' ').trim();
      //       }
      //    }

      //    // Now check if we have any RAM or storage specifications
      //    const specs = ['ram', 'storage']
      //       .map((specField) => getCurrentComponentInName(specField, rowData))
      //       .filter(Boolean);

      //    if (specs.length > 0) {
      //       // We have specs, add the new series name at the beginning
      //       return `${newFullSeriesName} ${nameWithoutAnySeries}`.trim();
      //    } else {
      //       // No specs were found, check if we have any color
      //       const colorComponent = getCurrentComponentInName('colorId', rowData);

      //       if (colorComponent) {
      //          // If we have a color but no other specs
      //          return `${newFullSeriesName} ${nameWithoutAnySeries}`.trim();
      //       } else {
      //          // No specs or color, so either the name is empty now or has other content
      //          if (nameWithoutAnySeries.trim() === '') {
      //             // Name is now empty after removing series, just use the new series name
      //             return newFullSeriesName;
      //          } else {
      //             // Name still has other content, add new series at beginning
      //             return `${newFullSeriesName} ${nameWithoutAnySeries}`.trim();
      //          }
      //       }
      //    }
      // }

      // Rest of the function remains unchanged
      // Handle RAM insertion specifically
      // if (field === 'ram') {
      //    // If there's already a RAM component, replace it
      //    if (currentComponent) {
      //       return currentName.replace(currentComponent, newComponentName).replace(/\s+/g, ' ').trim();
      //    }

      //    // If there's no RAM but there's storage, insert RAM before storage
      //    const storageComponent = getCurrentComponentInName('storage', rowData);
      //    if (storageComponent) {
      //       return currentName
      //          .replace(storageComponent, `${newComponentName} ${storageComponent}`)
      //          .replace(/\s+/g, ' ')
      //          .trim();
      //    }

      //    // If there's no storage either, add RAM after series
      //    const seriesComponent = getCurrentComponentInName('seriesId', rowData);
      //    if (seriesComponent) {
      //       // Add RAM right after the series
      //       const seriesIndex = currentName.indexOf(seriesComponent) + seriesComponent.length;
      //       const beforeSeries = currentName.substring(0, seriesIndex);
      //       const afterSeries = currentName.substring(seriesIndex).trim();

      //       return `${beforeSeries} ${newComponentName} ${afterSeries}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // If no series either, add RAM to the end
      //    return `${currentName} ${newComponentName}`.trim();
      // }

      // Handle storage insertion
      // if (field === 'storage') {
      //    // If there's already a storage component, replace it
      //    if (currentComponent) {
      //       return currentName.replace(currentComponent, newComponentName).replace(/\s+/g, ' ').trim();
      //    }

      //    // If there's no storage but there's RAM, insert storage after RAM
      //    const ramComponent = getCurrentComponentInName('ram', rowData);
      //    if (ramComponent) {
      //       const ramIndex = currentName.indexOf(ramComponent) + ramComponent.length;
      //       const beforeRam = currentName.substring(0, ramIndex);
      //       const afterRam = currentName.substring(ramIndex).trim();

      //       return `${beforeRam} ${newComponentName} ${afterRam}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // If no RAM, add storage after series
      //    const seriesComponent = getCurrentComponentInName('seriesId', rowData);
      //    if (seriesComponent) {
      //       const seriesIndex = currentName.indexOf(seriesComponent) + seriesComponent.length;
      //       const beforeSeries = currentName.substring(0, seriesIndex);
      //       const afterSeries = currentName.substring(seriesIndex).trim();

      //       return `${beforeSeries} ${newComponentName} ${afterSeries}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // If no series either, add storage to the end
      //    return `${currentName} ${newComponentName}`.trim();
      // }

      // For color field, check if color exists and replace it
      // if (field === 'colorId') {
      //    if (currentComponent) {
      //       return currentName.replace(currentComponent, newComponentName).replace(/\s+/g, ' ').trim();
      //    }

      //    // MODIFIED: Always add color at the end (after storage if present)
      //    const storageComponent = getCurrentComponentInName('storage', rowData);
      //    if (storageComponent) {
      //       const storageIndex = currentName.indexOf(storageComponent) + storageComponent.length;
      //       const beforeStorage = currentName.substring(0, storageIndex);
      //       const afterStorage = currentName.substring(storageIndex).trim();

      //       return `${beforeStorage} ${newComponentName} ${afterStorage}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // If no storage, try to add after RAM
      //    const ramComponent = getCurrentComponentInName('ram', rowData);
      //    if (ramComponent) {
      //       const ramIndex = currentName.indexOf(ramComponent) + ramComponent.length;
      //       const beforeRam = currentName.substring(0, ramIndex);
      //       const afterRam = currentName.substring(ramIndex).trim();

      //       return `${beforeRam} ${newComponentName} ${afterRam}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // If no RAM or storage, add after series
      //    const seriesComponent = getCurrentComponentInName('seriesId', rowData);
      //    if (seriesComponent) {
      //       const seriesIndex = currentName.indexOf(seriesComponent) + seriesComponent.length;
      //       const beforeSeries = currentName.substring(0, seriesIndex);
      //       const afterSeries = currentName.substring(seriesIndex).trim();

      //       return `${beforeSeries} ${newComponentName} ${afterSeries}`.replace(/\s+/g, ' ').trim();
      //    }

      //    // When all else fails, add to the end
      //    return `${currentName} ${newComponentName}`.trim();
      // }

      // For other fields, replace the current component with the new one
      if (currentComponent) {
         return currentName.replace(currentComponent, newComponentName).replace(/\s+/g, ' ').trim();
      } else {
         // If no current component, add to the end
         return `${currentName} ${newComponentName}`.trim();
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => {
         // const newRow = { ...prev, [field]: value };
         if (field === 'categoryid') {
            const newRow = { ...prev, [field]: Number(value) };
            return newRow;
         } else {
            const newRow = { ...prev, [field]: value };
            return newRow;
         }

         // Only update product name for specific dropdown fields
         // seriesId
         // if (['seriesId','colorId', 'ram', 'storage'].includes(field)) {
         //    newRow.name = updateProductNameFromDropdown(field, value, newRow);
         // }

         // return newRow;
      });
   };

   // const parseProductName = (productName) => {
   //    const name = productName; // Keep original case for matching
   //    let result = {
   //       name: productName,
   //       seriesId: null,
   //       colorId: null,
   //       ram: null,
   //       storage: null,
   //    };

   //    // Extract all GB and TB values before series matching to prevent series names from interfering
   //    const gbPattern = /(\d+)(?:\s*|\s+)GB/gi;
   //    const tbPattern = /(\d+)(?:\s*|\s+)TB/i;

   //    const gbMatches = Array.from(name.matchAll(gbPattern));
   //    const tbMatch = name.match(tbPattern);

   //    // Keep track of the GB values we've already processed
   //    let processedGbValues = [];

   //    // STEP 1: Find series match by looking for exact brand name matches first
   //    // This handles the case where different brands have the same model number (like "12")
   //    const nameLower = name.toLowerCase();
   //    let bestMatchSeries = null;
   //    let bestMatchScore = 0;

   //    // First pass: try to match brand names from the product name
   //    for (const series of seriesData) {
   //       // Skip invalid series
   //       if (!series || !series.brandname) continue;

   //       const brandName = series.brandname.toLowerCase();
   //       const printName = series.printName ? series.printName.toLowerCase() : null;

   //       // Skip series with brand names containing GB or TB to avoid confusion with specs
   //       if (brandName.includes('gb') || brandName.includes('tb')) continue;

   //       // Calculate match score - check for brand name in product name
   //       let matchScore = 0;

   //       // Check for brand name match (e.g., "ONEPLUS")
   //       if (nameLower.includes(brandName)) {
   //          matchScore += 5; // High priority for brand name match
   //       }

   //       // Check for print name match if available (e.g., "ONEPLUS")
   //       if (printName && nameLower.includes(printName)) {
   //          matchScore += 5; // Additional points for printName match
   //       }

   //       // If both brandname and series number are present, give highest priority
   //       // Example: "oneplus 12" should match ONEPLUS brand with model "12"
   //       if (matchScore > 0 && series.name) {
   //          const seriesNumber = series.name.toLowerCase();
   //          const combinedPattern = new RegExp(
   //             `\\b${escapeRegExp(brandName)}\\s+${escapeRegExp(seriesNumber)}\\b|\\b${escapeRegExp(
   //                printName || '',
   //             )}\\s+${escapeRegExp(seriesNumber)}\\b`,
   //             'i',
   //          );

   //          if (combinedPattern.test(nameLower)) {
   //             matchScore += 10; // Highest priority for exact brand+model match
   //          }
   //       }

   //       // Update best match if this series has a higher score
   //       if (matchScore > bestMatchScore) {
   //          bestMatchScore = matchScore;
   //          bestMatchSeries = series;
   //       }
   //    }

   //    // Use the best match if found
   //    if (bestMatchSeries) {
   //       result.seriesId = bestMatchSeries.id;
   //    }

   //    // Fallback to generic series matching if no brand match found
   //    if (!result.seriesId) {
   //       // Sort series data to prioritize full names over just numbers
   //       const sortedSeriesData = [...seriesData].sort((a, b) => {
   //          // For series with same name like "12", prioritize by brand name presence in product name
   //          if (a.name === b.name) {
   //             const aNameMatch = nameLower.includes((a.brandname || '').toLowerCase());
   //             const bNameMatch = nameLower.includes((b.brandname || '').toLowerCase());
   //             if (aNameMatch !== bNameMatch) return aNameMatch ? -1 : 1;
   //          }

   //          // Then prioritize by name length (longer names first)
   //          return b.name.length - a.name.length;
   //       });
   //    }

   //    // STEP 2: Find color match
   //    for (const color of colorData) {
   //       // Modified: Use word boundary for color and handle "COLOUR" keyword
   //       const colorRegex = new RegExp(
   //          `\\b${escapeRegExp(color.name)}\\b(?:\\s+COLOU?R)?|\\bCOLOU?R\\s+${escapeRegExp(color.name)}\\b`,
   //          'i',
   //       );
   //       if (colorRegex.test(name)) {
   //          result.colorId = color.id;
   //          break;
   //       }
   //    }

   //    // STEP 3: Handle TB storage specifically first (always storage)
   //    if (tbMatch) {
   //       const tbValue = parseInt(tbMatch[1]);
   //       // Use the TB value directly for storage lookup
   //       let storageOption = STORAGE_TYPE.find((storage) => storage.name && storage.name.includes(`${tbValue}TB`));

   //       if (!storageOption) {
   //          // If no direct match by name, try matching by value
   //          storageOption = STORAGE_TYPE.find((storage) => storage.value === tbValue * 1024); // Convert TB to GB
   //       }

   //       // Last resort: use tolerance
   //       if (!storageOption) {
   //          storageOption = STORAGE_TYPE.find(
   //             (storage) => storage.value && Math.abs(storage.value - tbValue * 1024) < 0.1 * tbValue * 1024,
   //          );
   //       }

   //       if (storageOption) {
   //          result.storage = storageOption.id;
   //       }
   //    }

   //    // STEP 4: Look for explicit storage indicators in GB values
   //    if (!result.storage && gbMatches.length > 0) {
   //       const storagePattern = /(\d+)(?:\s*|\s+)GB(?:\s+)Storage/i;
   //       const storageMatch = name.match(storagePattern);

   //       if (storageMatch) {
   //          const value = parseInt(storageMatch[1]);
   //          processedGbValues.push(value); // Mark this value as processed

   //          // Try exact match first by value
   //          let storageOption = STORAGE_TYPE.find((storage) => storage.value === value);

   //          // Fall back to tolerance match if needed
   //          if (!storageOption) {
   //             storageOption = STORAGE_TYPE.find(
   //                (storage) => storage.value && Math.abs(storage.value - value) < 0.1 * value,
   //             );
   //          }

   //          if (storageOption) {
   //             result.storage = storageOption.id;
   //          }
   //       }
   //    }

   //    // STEP 5: Process remaining GB values for RAM and storage
   //    if (gbMatches.length > 0) {
   //       // Detect RAM first - RAM values are typically lower (1-16GB)
   //       let ramFound = false;
   //       let lowestGbValue = Infinity;
   //       let highestGbValue = 0;

   //       // First identify likely RAM and storage values by size
   //       for (const match of gbMatches) {
   //          const value = parseInt(match[1]);

   //          // Skip already processed values
   //          if (processedGbValues.includes(value)) continue;

   //          // Track min and max values
   //          if (value < lowestGbValue) lowestGbValue = value;
   //          if (value > highestGbValue) highestGbValue = value;
   //       }

   //       // Try to assign RAM (smaller value) and storage (larger value)
   //       for (const match of gbMatches) {
   //          const value = parseInt(match[1]);

   //          // Skip already processed values
   //          if (processedGbValues.includes(value)) continue;

   //          // RAM is typically lower values (1-16GB)
   //          if (!ramFound && value === lowestGbValue && value <= 32) {
   //             // Check for RAM indicators
   //             const isExplicitRam = match[0].toLowerCase().includes('ram');
   //             const ramContext = name.substring(
   //                Math.max(0, match.index - 10),
   //                Math.min(name.length, match.index + match[0].length + 10),
   //             );

   //             if (isExplicitRam || !ramContext.toLowerCase().includes('storage')) {
   //                // Try exact RAM match first
   //                let ramOption = RAM_TYPE.find((ram) => ram.value === value);

   //                // Only fall back to tolerance if no exact match
   //                if (!ramOption) {
   //                   ramOption = RAM_TYPE.find((ram) => ram.value && Math.abs(ram.value - value) < 0.05 * value);
   //                }

   //                if (ramOption) {
   //                   result.ram = ramOption.id;
   //                   processedGbValues.push(value);
   //                   ramFound = true;
   //                   continue;
   //                }
   //             }
   //          }

   //          // If the value isn't processed as RAM, try it as storage
   //          if (!result.storage && !processedGbValues.includes(value)) {
   //             // Higher values or values with storage indicators
   //             const isExplicitStorage = match[0].toLowerCase().includes('storage');
   //             const isHigherValue = value === highestGbValue && value >= 16;

   //             if (isExplicitStorage || isHigherValue) {
   //                let storageOption = STORAGE_TYPE.find((storage) => storage.value === value);

   //                if (!storageOption) {
   //                   storageOption = STORAGE_TYPE.find(
   //                      (storage) => storage.value && Math.abs(storage.value - value) < 0.1 * value,
   //                   );
   //                }

   //                if (storageOption) {
   //                   result.storage = storageOption.id;
   //                   processedGbValues.push(value);
   //                }
   //             }
   //          }
   //       }

   //       // Second pass to handle any remaining values
   //       for (const match of gbMatches) {
   //          const value = parseInt(match[1]);

   //          // Skip already processed values
   //          if (processedGbValues.includes(value)) continue;

   //          // If RAM not found yet, try to use this value
   //          if (!result.ram) {
   //             let ramOption = RAM_TYPE.find((ram) => ram.value === value);

   //             if (!ramOption) {
   //                ramOption = RAM_TYPE.find((ram) => ram.value && Math.abs(ram.value - value) < 0.05 * value);
   //             }

   //             if (ramOption) {
   //                result.ram = ramOption.id;
   //                processedGbValues.push(value);
   //                continue;
   //             }
   //          }

   //          // If storage not found yet, try to use this value
   //          if (!result.storage) {
   //             let storageOption = STORAGE_TYPE.find((storage) => storage.value === value);

   //             if (!storageOption) {
   //                storageOption = STORAGE_TYPE.find(
   //                   (storage) => storage.value && Math.abs(storage.value - value) < 0.1 * value,
   //                );
   //             }

   //             if (storageOption) {
   //                result.storage = storageOption.id;
   //                processedGbValues.push(value);
   //             }
   //          }
   //       }
   //    }

   //    return result;
   // };

   // Helper function to escape special characters in regex

   // const parseProductName = useCallback(
   //    (productName) => {
   //       // EXTRACT RAM IN TO NAME
   //       const RAM_REGEX = /\b(1[0-9]|2[0-4]|[1-9])\s?GB\b/i;
   //       const ramMatch = productName.match(RAM_REGEX);
   //       const ramName = ramMatch ? ramMatch[0].replace(/(\d+)([A-Za-z]+)/, '$1 $2') : '';
   //       const ramId = ramMatch
   //          ? RAM_TYPE.find((r) => r.name.toUpperCase() === ramName.toUpperCase())?.id ?? 0
   //          : 0;

   //       // Extract Color
   //       const colorMatch = colorData.find((c) =>
   //          productName.toLowerCase().includes(c.name.toLowerCase())
   //       );
   //       const colorId = colorMatch?.id ?? null;

   //       // Extract Storage (take 2nd match if exists, else fallback to 1st)
   //       const STORAGE_REGEX = /\b(\d{2,4})\s?(GB|TB)\b/gi;
   //       const storageMatches = [...productName.matchAll(STORAGE_REGEX)];
   //       let storageMatch = '';
   //       if (storageMatches.length > 0) {
   //          const index = storageMatches.length >= 2 ? 1 : 0;
   //          const [_, value, unit] = storageMatches[index];
   //          storageMatch = `${value} ${unit.toUpperCase()}`;
   //       }

   //       // const storageName = storageMatch ? storageMatch?.replace(/(\d*\.?\d+)([A-Za-z]+)/, '$1 $2') : '';
   //       // const storageId = STORAGE_TYPE.find((r) => r.name.toUpperCase() === storageName.toUpperCase())?.id ?? 0;
   //       const storageId = storageMatch
   //          ? STORAGE_TYPE.find((r) => r.name.toUpperCase() === storageMatch.toUpperCase())?.id ?? 0
   //          : 0;

   //       // const seriesMatch = seriesData.find((s) => {
   //       //    let seriesName = s.printName.toUpperCase() + ' ' + s.name.toUpperCase();
   //       //    return extractModelName(productName).toUpperCase() === seriesName;
   //       // });
   //       // const seriesId = seriesMatch ? seriesMatch.id : null;

   //       setRow((prev) => ({
   //          ...prev,
   //          ram: ramId,
   //          colorId: colorId,
   //          storage: storageId,
   //          // seriesId: seriesId,
   //       }));
   //    },
   //    [colorData],
   // );

   const parseProductName = useCallback(
      (productName) => {
         const STORAGE_TYPE_LOOKUP = (value, unit) =>
            STORAGE_TYPE.find((r) => r.name.toUpperCase() === `${value} ${unit}`)?.id ?? 0;

         const RAM_TYPE_LOOKUP = (value) => RAM_TYPE.find((r) => r.name.toUpperCase() === `${value} GB`)?.id ?? 0;

         const STORAGE_REGEX = /\b(\d{1,4})\s?(GB|TB)\b/gi;
         const matches = [...productName.matchAll(STORAGE_REGEX)];

         let ramId = 0;
         let storageId = 0;

         if (matches.length === 1) {
            const [_, valueRaw, unitRaw] = matches[0];
            const value = parseInt(valueRaw);
            const unit = unitRaw.toUpperCase();

            if (unit === 'GB' && value <= 16) {
               // Single low-value GB → treat as RAM
               ramId = RAM_TYPE_LOOKUP(value);
            } else {
               // Larger or TB → treat as Storage
               storageId = STORAGE_TYPE_LOOKUP(value, unit);
            }
         } else if (matches.length >= 2) {
            // First match is RAM, second is Storage
            const [ramRaw, ramUnit] = [matches[0][1], matches[0][2].toUpperCase()];
            const [storageRaw, storageUnit] = [matches[1][1], matches[1][2].toUpperCase()];

            const ramValue = parseInt(ramRaw);
            const storageValue = parseInt(storageRaw);

            if (ramUnit === 'GB' && ramValue <= 16) {
               ramId = RAM_TYPE_LOOKUP(ramValue);
               storageId = STORAGE_TYPE_LOOKUP(storageValue, storageUnit);
            } else {
               // fallback in case first value is high (e.g., 128GB, 512GB)
               storageId = STORAGE_TYPE_LOOKUP(ramValue, ramUnit);
               ramId = RAM_TYPE_LOOKUP(storageValue); // try as RAM
            }
         }

         // Extract color
         const colorMatch = colorData.find((c) => productName.toLowerCase().includes(c.name.toLowerCase()));
         const colorId = colorMatch?.id ?? null;

         setRow((prev) => ({
            ...prev,
            ram: ramId,
            colorId: colorId,
            storage: storageId,
         }));
      },
      [colorData],
   );

   function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
   }

   const generateFullProductName = (rowData) => {
      let nameParts = [];

      // Add series name if selected
      // if (rowData.seriesId) {
      //    const series = seriesData.find((s) => s.id === rowData.seriesId);
      //    if (series) {
      //       nameParts.push(series.name + ' ' + series.printName);
      //    }
      // }
      if (rowData.seriesId) {
         const series = seriesData.find((s) => s.id === rowData.seriesId);
         if (series) {
            nameParts.push(series.name); // No more printName
         }
      }

      // Add color if selected (always after series but before specs)
      if (rowData.colorId) {
         const color = colorData.find((c) => c.id === rowData.colorId);
         if (color) {
            nameParts.push(color.name.toUpperCase());
         }
      }

      // Add RAM if selected
      if (rowData.ram) {
         const ram = RAM_TYPE.find((r) => r.id === rowData.ram);
         if (ram) {
            // Just add the value without "RAM" for consistency
            nameParts.push(`${ram.value}GB`);
         }
      }

      // Add storage if selected
      if (rowData.storage) {
         const storage = STORAGE_TYPE.find((s) => s.id === rowData.storage);
         if (storage) {
            // Format storage as TB if >= 1000GB
            if (storage.value >= 1000) {
               const tbValue = storage.value / 1024;
               nameParts.push(`${tbValue}TB`);
            } else {
               nameParts.push(`${storage.value}GB`);
            }
         }
      }

      // Join all parts with a space
      return nameParts.join(' ');
   };

   // Handle name input change with auto-parsing functionality
   const handleNameInputChange = (e) => {
      const productName = e.target.value;

      // Update the name field
      setRow((prev) => ({
         ...prev,
         name: productName,
      }));

      // Clear any name field errors
      setErrors((prev) => {
         const newErrors = { ...prev };
         if (newErrors.name) {
            delete newErrors.name;
         }
         return newErrors;
      });
   };

   const handleNameInputBlur = () => {
      const productName = row.name;

      if (productName.length > 3) {
         // Parse the product name
         const parsedValues = parseProductName(productName);

         // Track if any values were actually changed
         let changesMade = false;

         // Update other fields if values were successfully parsed
         setRow((prev) => {
            const newRow = { ...prev };

            // Only update fields if new values were found
            if (parsedValues?.seriesId && parsedValues?.seriesId !== prev.seriesId) {
               newRow.seriesId = parsedValues?.seriesId;
               changesMade = true;
            }

            if (parsedValues?.colorId && parsedValues?.colorId !== prev.colorId) {
               newRow.colorId = parsedValues?.colorId;
               changesMade = true;
            }

            if (parsedValues?.ram && parsedValues?.ram !== prev.ram) {
               newRow.ram = parsedValues?.ram;
               changesMade = true;
            }

            if (parsedValues?.storage && parsedValues?.storage !== prev.storage) {
               newRow.storage = parsedValues?.storage;
               changesMade = true;
            }

            return newRow;
         });

         // Only show feedback if changes were made
         if (changesMade) {
            toast({
               title: 'Fields auto-populated',
               description: 'Product details were automatically detected',
               status: 'info',
               duration: 3000,
               isClosable: true,
               position: 'top',
            });
         }
      }
   };

   // Manual parse button handler
   const handleParseProductName = () => {
      const productName = row.name;

      if (productName.length > 3) {
         // Parse the product name
         const parsedValues = parseProductName(productName);

         // Track changes made for feedback
         let changesMade = {
            series: false,
            color: false,
            ram: false,
            storage: false,
         };

         // Update other fields if values were successfully parsed
         setRow((prev) => {
            const newRow = { ...prev };

            // Only update fields if new values were found
            if (parsedValues.seriesId) {
               newRow.seriesId = parsedValues.seriesId;
               changesMade.series = parsedValues.seriesId !== prev.seriesId;
            }

            if (parsedValues.colorId) {
               newRow.colorId = parsedValues.colorId;
               changesMade.color = parsedValues.colorId !== prev.colorId;
            }

            if (parsedValues.ram) {
               newRow.ram = parsedValues.ram;
               changesMade.ram = parsedValues.ram !== prev.ram;
            }

            if (parsedValues.storage) {
               newRow.storage = parsedValues.storage;
               changesMade.storage = parsedValues.storage !== prev.storage;
            }

            return newRow;
         });

         // Create a message about what was detected
         const detectedItems = [];
         if (changesMade.series) detectedItems.push('Series');
         if (changesMade.color) detectedItems.push('Color');
         if (changesMade.ram) detectedItems.push('RAM');
         if (changesMade.storage) detectedItems.push('Storage');

         const description =
            detectedItems.length > 0 ? `Detected: ${detectedItems.join(', ')}` : 'No new values detected';

         toast({
            title: 'Fields populated',
            description,
            status: detectedItems.length > 0 ? 'success' : 'info',
            duration: 3000,
            isClosable: true,
            position: 'top',
         });
      } else {
         toast({
            title: 'Product name too short',
            description: 'Please enter a valid product name',
            status: 'warning',
            duration: 3000,
            isClosable: true,
            position: 'top',
         });
      }
   };

   const handleFileChange = (e) => {
      if (e.target.files.length > 0) {
         const file = e.target.files[0];
         if (file) {
            setRow((prev) => ({ ...prev, image: file }));
         }
      }
   };

   const handleSwitchChange = (field) => (event) => {
      setRow((prev) => ({
         ...prev,
         [field]: event.target.checked, // Updates boolean value (true/false)
      }));
   };

   const handlePrevious = () => {
      if (activeStep > 0) {
         setActiveStep(activeStep - 1);
      }
   };

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const onFormSubmit = async () => {
      const isValid = await validateStep();
      if (!isValid) {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }
      try {
         setIsLoadingbt(true);
         const processedData = {
            ...row,
            companyIds: row.companyIds,
            categoryid: row.categoryid,
         };

         delete processedData.hsn;
         delete processedData.hsnData;
         delete processedData.createdU;
         delete processedData.updatedU;
         delete processedData.uqc1Data;
         delete processedData.uqc2Data;
         delete processedData.uqc3Data;
         delete processedData.parentName;
         delete processedData.vendorName;
         delete processedData.itemGroupName;
         delete processedData.primaryUqcData;
         delete processedData.value;
         delete processedData.label;
         delete processedData.stock;
         delete processedData.salesreport;
         delete processedData.purchasereport;
         delete processedData.gstpercentage;

         processedData.uqcid2 = company.setting.maxUOM > 1 ? processedData.uqcid2 : processedData.uqcid1;
         processedData.uqcid3 = company.setting.maxUOM >= 3 ? processedData.uqcid3 : processedData.uqcid1;

         processedData.purchaseprice = Number(processedData.purchaseprice);
         if (!mobile) {
            delete processedData.battery;
            delete processedData.storage;
            delete processedData.seriesId;
            delete processedData.mrp;
            delete processedData.colorId;
            delete processedData.ram;
            delete processedData.cellular;
            delete processedData.gst;
            delete processedData.order;
            delete processedData.network;
            delete processedData.display;
            delete processedData.displayType;
            delete processedData.frontCamera;
            delete processedData.rearCamera;
            delete processedData.processor;
            delete processedData.mmSize;
         }

         const formData = new FormData();

         Object.entries(processedData).forEach(([key, value]) => {
            if (
               key === 'isAbs' ||
               key === 'isabs' ||
               key === 'sacData' ||
               key === 'createdAt' ||
               key === 'createdBy' ||
               key === 'updatedAt' ||
               key === 'updatedBy'
            ) {
               // formData.append(key, undefined);
            } else if (value === null || value === undefined) {
               formData.append(key, '');
            } else if (typeof value === 'boolean') {
               formData.append(key, value ? 'true' : 'false');
            } else if (key === 'categoryid') {
               // Convert to number first, then to string
               formData.append(key, value);
            } else if (key === 'companyIds') {
               formData.append(key, [value]);
            } else {
               formData.append(key, value);
            }
         });

         if (isEditMode && currentRow?.id) {
            // processedData.id = currentRow.id;
            // formData.append('id', currentRow.id);
            const response = await dispatch(updateItem(formData));
            if (response?.code === 1) {
               onSave(response.data);
            }
         } else {
            const response = await dispatch(addItem(formData));
            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         dispatch(
            getItems({
               companyId: user.loginhistory.companyId,
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               search: searchQuery,
               sortBy: sorting?.length ? sorting[0]?.name : 'name',
               sortOrder: sorting?.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );
         dispatch(
            getItemForMaster({
               companyId: user.loginhistory.companyId,
               sortBy: 'name',
               sortOrder: 'asc',
            }),
         );
         await dispatch(
            getItem({
               companyId: user.loginhistory.companyId,
               ...(shouldSendCompanyidItem && { companyIds: user.loginhistory.companyId }),
               sortBy: 'name',
               sortOrder: 'asc',
            }),
         );
         handleOnClose();
         setIsLoadingbt(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoadingbt(false);
      }
   };

   const handleSaveAndContinue = async () => {
      const isValid = await validateStep();
      if (!isValid) {
         if (!row.name || row.name.trim() === '') {
            setActiveStep(0);

            setTimeout(() => {
               nameInputRef.current?.focus(); // Focus the name input
            }, 100);

            return;
         }
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }
      try {
         setIsLoadingbt(true);
         const processedData = {
            ...row,
            categoryid: Number(row.categoryid),
         };

         delete processedData.hsn;
         delete processedData.hsnData;
         delete processedData.createdU;
         delete processedData.updatedU;
         delete processedData.uqc1Data;
         delete processedData.uqc2Data;
         delete processedData.uqc3Data;
         delete processedData.parentName;
         delete processedData.vendorName;
         delete processedData.itemGroupName;
         delete processedData.primaryUqcData;

         processedData.uqcid2 = company.setting.maxUOM > 1 ? processedData.uqcid2 : processedData.uqcid1;
         processedData.uqcid3 = company.setting.maxUOM >= 3 ? processedData.uqcid3 : processedData.uqcid1;

         processedData.purchaseprice = Number(processedData.purchaseprice);

         const formData = new FormData();
         Object.entries(processedData).forEach(([key, value]) => {
            if (value === null || value === undefined) {
               formData.append(key, '');
            } else if (typeof value === 'boolean') {
               formData.append(key, value ? 'true' : 'false');
            } else {
               formData.append(key, value);
            }
         });

         if (isEditMode && currentRow?.id) {
            formData.append('id', currentRow.id);
            // processedData.id = currentRow.id;
            dispatch(updateItem(formData));
         } else {
            const response = await dispatch(addItem(formData));
            if (response?.code === 1) {
               onSave(response.data);
            }
         }
         setActiveStep(0);
         clearFormData();
         await dispatch(
            getItems({
               companyId: user.loginhistory.companyId,
               page: currentPage,
               // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
               search: searchQuery,
               sortBy: sorting?.length ? sorting[0]?.name : 'name',
               sortOrder: sorting?.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
            }),
         );

         await dispatch(
            getItemForMaster({
               companyId: user.loginhistory.companyId,
               sortBy: 'name',
               sortOrder: 'asc',
            }),
         );
         await dispatch(
            getItem({
               companyId: user.loginhistory.companyId,
               search: searchQuery,
               sortBy: 'name',
               sortOrder: 'asc',
            }),
         );
         setIsLoadingbt(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the Daybook.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoadingbt(false);
      }
   };

   const handleNext = async () => {
      const isValid = await validateStep();
      if (isValid) {
         if (activeStep < steps.length - 1) {
            setActiveStep(activeStep + 1);
         } else {
            onFormSubmit();
         }
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const setDefualtValue = useCallback(() => {
      if (isOpen && company && !isEditMode) {
         setRow((prev) => ({
            ...prev,
            uqcid1: company?.setting?.UOM1,
            uqcid2: company?.setting?.UOM2,
            uqcid3: company?.setting?.UOM3,
            hsnid: company?.setting?.defaultHSN,
            sacid: company?.setting?.defaultSAC,
            itemgroupid: company?.setting?.itemGroupId,
            ratepersalesid: company.setting.primaryUnit,
            rateperpurchaseid: company.setting.primaryUnit,
            itemdetailtype: company.setting.itemDetailType,
            companyIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
            // ratepersalesid: company.setting.maxUOM >= 1 ? company.setting.UOM1 : 0,
            // rateperpurchaseid:
            //    company.setting.maxUOM > 1 && company.setting.maxUOM <= 3
            //       ? company.setting.UOM2
            //       : company.setting.maxUOM === 2
            //       ? company.setting.UOM2
            //       : company.setting.UOM1,
            primaryuqcid: company.setting.primaryUnit,
         }));
      }
   }, [company, isEditMode, isOpen]);

   const handleOnClose = useCallback(() => {
      setActiveStep(0);
      clearFormData();
      onClose();
   }, [clearFormData, onClose]);

   useEffect(() => {
      if (demoname && row.name === '') {
         setRow((prev) => ({ ...prev, name: demoname }));
      }
      demoname = '';
   }, [demoname, row.name]);

   useEffect(() => {
      if (businessTypes && businessTypes?.businessType === 'MOBILE') {
         if (!steps.find((x) => x.step === 4)) {
            steps.push({
               title: 'Mobile Details',
               description: 'Enter the mobile details',
               step: 4,
            });
         }
         setRow({ ...row, itemdetailtype: 1 });
      }
   }, [businessTypes, businessTypes?.businessType]);

   useEffect(() => {
      if (isOpen) {
         setIsLoading(true);
         setDataFetched(false);

         // Prepare the list of promises to fetch data
         const fetchPromises = [
            dispatch(getMainAndSubHsn()),
            dispatch(getHsn()),
            dispatch(
               getItemGroup({ ...(shouldSendCompanyidItemGroup && { companyIds: user?.loginhistory?.companyId }) }),
            ),
            dispatch(
               getCategory({ ...(shouldSendCompanyidCategory && { companyIds: user?.loginhistory?.companyId }) }),
            ),
            dispatch(getUnit()),
            dispatch(
               getVendors({
                  type: ACCOUNT_TYPE.VENDOR,
                  ...(shouldSendCompanyidAccount && { companyIds: user?.loginhistory?.companyId }),
               }),
            ),
            dispatch(
               getItems({
                  companyId: user.loginhistory.companyId,
                  page: currentPage,
                  // limit: limit === pagination?.totalProducts ? undefined : limit, // undefined fetches everything
                  search: searchQuery,
                  sortBy: sorting?.length ? sorting[0]?.name : 'name',
                  sortOrder: sorting?.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
                  ...(shouldSendCompanyidItem && { companyIds: user?.loginhistory?.companyId }),
               }),
            ),
         ];

         // Only fetch mobile-specific data if needed
         if (businessTypes?.businessType === 'MOBILE') {
            fetchPromises.push(
               dispatch(getSeries({ ...(shouldSendCompanyidSeries && { companyIds: user?.loginhistory?.companyId }) })),
            );
            fetchPromises.push(
               dispatch(getColor({ ...(shouldSendCompanyidColor && { companyIds: user?.loginhistory?.companyId }) })),
            );
         } else {
            dispatch(getItemByFinishItem());
         }

         // Execute all promises and mark data as fetched when done
         Promise.all(fetchPromises)
            .then(() => {
               setDataFetched(true);
               // Add a slight delay to ensure state updates
               setTimeout(() => {
                  checkDataLoaded();
               }, 300);
            })
            .catch((error) => {
               console.error('Error fetching data:', error);
               setIsLoading(false);
               toast({
                  title: 'Error',
                  description: 'Failed to load necessary data. Please try again.',
                  status: 'error',
                  duration: 3000,
                  isClosable: true,
               });
            });
      }
   }, [dispatch, isOpen, businessTypes?.businessType]);

   useEffect(() => {
      if (isOpen) {
         checkDataLoaded();
      }
   }, [isOpen, dataFetched]);
   /////////////////////////////////////

   useEffect(() => {
      const selectedUnits = [];

      // Helper function to add unit to options if it exists
      const addUnitIfSelected = (unitId, unitNumber) => {
         if (unitId) {
            const selectedUnit = uqc.find((unit) => unit.id === Number(unitId));
            if (selectedUnit) {
               selectedUnits.push({
                  ...selectedUnit,
                  label: `${selectedUnit.name} (Unit ${unitNumber})`,
               });
            }
         }
      };

      // Add selected units in order
      addUnitIfSelected(row.uqcid1, '1');
      addUnitIfSelected(row.uqcid2, '2');
      addUnitIfSelected(row.uqcid3, '3');

      setRatePerSalesOptions(selectedUnits);

      // Reset rates if they become invalid
      //const isValidSalesSelection = selectedUnits.some((unit) => unit.id === Number(row.ratepersalesid));
      //const isValidPurchaseSelection = selectedUnits.some((unit) => unit.id === Number(row.rateperpurchaseid));

      // if (!isValidSalesSelection) {
      //    setRow((prev) => ({ ...prev, ratepersalesid: '' }));
      // }
      // if (!isValidPurchaseSelection) {
      //    setRow((prev) => ({ ...prev, rateperpurchaseid: '' }));
      // }
   }, [row.rateperpurchaseid, row.ratepersalesid, row.uqcid1, row.uqcid2, row.uqcid3, uqc]);

   // useEffect(() => {
   //    // Only create options when we have uqc data available
   //    if (uqc && uqc.length > 0) {
   //       const selectedUnits = [];

   //       // Helper function to add unit to options if it exists
   //       const addUnitIfSelected = (unitId, unitNumber) => {
   //          if (unitId) {
   //             const selectedUnit = uqc.find((unit) => unit.id === Number(unitId));
   //             if (selectedUnit) {
   //                selectedUnits.push({
   //                   ...selectedUnit,
   //                   label: `${selectedUnit.name} (Unit ${unitNumber})`,
   //                });
   //             }
   //          }
   //       };

   //       // Add selected units in order
   //       addUnitIfSelected(row.uqcid1, '1');
   //       addUnitIfSelected(row.uqcid2, '2');
   //       addUnitIfSelected(row.uqcid3, '3');

   //       setRatePerSalesOptions(selectedUnits);
   //    }
   // }, [row.uqcid1, row.uqcid2, row.uqcid3, uqc]);

   useEffect(() => {
      if (isOpen && isEditMode && currentRow) {
         setRow(() => ({
            ...currentRow,
            companyIds: currentRow?.companyIds || [],
            uqcid1: currentRow.uqcid1 ? currentRow.uqcid1 : company?.setting?.UOM1,
            uqcid2: currentRow.uqcid2 ? currentRow.uqcid2 : company?.setting?.UOM2,
            uqcid3: currentRow.uqcid3 ? currentRow.uqcid3 : company?.setting?.UOM3,
            ratepersalesid: currentRow.ratepersalesid
               ? currentRow.ratepersalesid
               : company?.setting?.maxUOM >= 1
               ? company?.setting?.UOM1
               : 0,
            rateperpurchaseid: currentRow.rateperpurchaseid
               ? currentRow.rateperpurchaseid
               : company?.setting.maxUOM > 1 && company?.setting.maxUOM <= 3
               ? company?.setting.UOM2
               : 0,
         }));
      }
   }, [
      company?.setting?.UOM1,
      company?.setting?.UOM2,
      company?.setting?.UOM3,
      company?.setting?.maxUOM,
      currentRow,
      isEditMode,
      isOpen,
   ]);

   // useEffect(() => {
   //    if (isOpen && user?.loginhistory?.companyId) {
   //       setCompany(companySetting());
   //    }
   // }, [companySetting, isOpen, user?.loginhistory?.companyId]);

   // useEffect(() => {
   //    if (isOpen && !isEditMode && company?.setting) {
   //       setRow((prev) => ({
   //          ...prev,
   //          uqcid1: company.setting.UOM1,
   //          uqcid2: company.setting.UOM2,
   //          uqcid3: company.setting.UOM3,
   //          hsnid: company.setting.defaultHSN,
   //          sacid: company.setting.defaultSAC,
   //          itemgroupid: company?.setting?.itemGroupId,
   //          ratepersalesid: company.setting.maxUOM >= 1 ? company.setting.UOM1 : 0,
   //          rateperpurchaseid:
   //             company.setting.maxUOM > 1 && company.setting.maxUOM <= 3
   //                ? company.setting.UOM2
   //                : company.setting.maxUOM === 2
   //                ? company.setting.UOM2
   //                : company.setting.UOM1,
   //          primaryuqcid: company.setting.primaryUnit,
   //       }));
   //    }
   // }, [company, isEditMode, isOpen]);

   useEffect(() => {
      setDefualtValue();
      return () => setDefualtValue();
   }, [setDefualtValue]);

   const nameInputRef = useRef(null);
   const [shouldFocus, setShouldFocus] = useState(false);

   useEffect(() => {
      if (isOpen) {
         setShouldFocus(true);
      }
   }, [isOpen]);

   useEffect(() => {
      if (shouldFocus && nameInputRef.current) {
         const timer = setTimeout(() => {
            nameInputRef?.current?.focus();
            setShouldFocus(false);
         }, 300);
         return () => clearTimeout(timer);
      }
   }, [shouldFocus, activeStep]); // Include activeStep if it affects visibility

   useEffect(() => {
      if (!isLoading) {
         setTimeout(() => {
            nameInputRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [!isLoading, , isOpen]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' || // for react-select input
            activeElement?.isContentEditable;

         if (isTyping) return; // Don't trigger shortcuts while typing

         if (isOpen && e.key.toLowerCase() === 's') {
            e.preventDefault();

            if (e.shiftKey) {
               handleSaveAndContinue(); // SHIFT + S --- save & continue
            } else {
               onFormSubmit(); // S --- Save & Finish
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            // onClose(); // c --- cansel
            handleOnClose();
         }
         if (isOpen && e.key.toLowerCase() === 'p') {
            handlePrevious(); // p --- Previous
         }
         if (isOpen && e.key.toLowerCase() === 'n') {
            handleNext(); // n --- next
         }
      };

      window.addEventListener('keydown', handleKeyDown);

      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            handleOnClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [handleOnClose]);

   const itemdetailtypeRef = useRef(null);
   const SeriesRef = useRef(null);
   const colorRef = useRef(null);
   const ramRef = useRef(null);
   const storageRef = useRef(null);
   const shortnameRef = useRef(null);
   const aliasnameRef = useRef(null);
   const printnameRef = useRef(null);
   const itemgroupeRef = useRef(null);
   const hsnRef = useRef(null);
   const sacRef = useRef(null);
   const uqcRef = useRef(null);
   const uqc2Ref = useRef(null);
   const uqc3Ref = useRef(null);
   const ratepersalesRef = useRef(null);
   const rateperpurchaseRef = useRef(null);
   const primaryuqcRef = useRef(null);
   const parentRef = useRef(null);
   const vendorRef = useRef(null);
   const imageRef = useRef(null);
   const nextRef = useRef(null);
   const defaultcutRef = useRef(null);
   const nameinotherlanguageRef = useRef(null);
   const additioninsalespriceRef = useRef(null);
   const warnabovemaxlvlRef = useRef(null);
   const salesprice3Ref = useRef(null);
   const minsalespriceRef = useRef(null);
   const salespriceperRef = useRef(null);
   const salesprice2Ref = useRef(null);
   const purchasebrokerageRef = useRef(null);
   const maxsalespriceRef = useRef(null);
   const salesprice1Ref = useRef(null);
   const purchasepriceRef = useRef(null);
   const purchasecostperRef = useRef(null);
   const purchasebrokeragetypeRef = useRef(null);
   const salesbrokerageRef = useRef(null);
   const actiononminmaxpriceRef = useRef(null);
   const defaultsellingqtyRef = useRef(null);
   const salesbrokeragetypeRef = useRef(null);
   const purchaseDisAmtRef = useRef(null);
   const finishItemRef = useRef(null);
   const saleDiscPerRef = useRef(null);
   const saleDiscAmtRef = useRef(null);
   const purchaseDiscPerRef = useRef(null);
   const reorderquantityRef = useRef(null);
   // const balancequantity1Ref = useRef(null);
   // const balancequantity2Ref = useRef(null);
   // const balancequantity3Ref = useRef(null);
   const foldpercentageRef = useRef(null);
   const reorderlevelRef = useRef(null);
   const wholesalerateRef = useRef(null);
   const stockrateRef = useRef(null);
   const minlevelRef = useRef(null);
   const warnbelowminlvlRef = useRef(null);
   const maxlevelRef = useRef(null);
   const warnbelowreorderRef = useRef(null);
   const stocknegativeactionRef = useRef(null);
   const savefinishRef = useRef(null);
   const codeRef = useRef(null);
   const barcodeRef = useRef(null);
   const lengthRef = useRef(null);
   const weightRef = useRef(null);
   const isassemblyRef = useRef(null);
   const itemtypeRef = useRef(null);
   const categoryRef = useRef(null);
   const heightRef = useRef(null);
   const widthRef = useRef(null);
   const calculatemtsRef = useRef(null);
   const uqcformat1Ref = useRef(null);
   const defaultquantity1Ref = useRef(null);
   const openingStock1Ref = useRef(null);
   const notesRef = useRef(null);
   // const packingname12Ref = useRef(null);
   const packing13Ref = useRef(null);
   // const packingname13Ref = useRef(null);
   const packing12Ref = useRef(null);
   // const packingname21Ref = useRef(null);
   const defaultquantity2Ref = useRef(null);
   const openingStock2Ref = useRef(null);
   const packing23Ref = useRef(null);
   // const packingname23Ref = useRef(null);
   const packing21Ref = useRef(null);
   const uqcformat2Ref = useRef(null);
   const cellularRef = useRef(null);
   const orderRef = useRef(null);
   const networkRef = useRef(null);
   const gstRef = useRef(null);
   const rearCameraRef = useRef(null);
   const processorRef = useRef(null);
   const mmSizeRef = useRef(null);
   const displayRef = useRef(null);
   const displayTypeRef = useRef(null);
   const frontCameraRef = useRef(null);
   const batteryRef = useRef(null);
   const mrpRef = useRef(null);
   const companyRef = useRef(null);

   useEffect(() => {
      if (activeStep === 1) {
         setTimeout(() => {
            actiononminmaxpriceRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 2) {
         setTimeout(() => {
            warnbelowreorderRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 3) {
         setTimeout(() => {
            codeRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   useEffect(() => {
      if (activeStep === 4) {
         setTimeout(() => {
            mrpRef.current?.focus();
         }, 100); // small delay sometimes helps
      }
   }, [activeStep]);

   const isMobileBusiness = businessType === 'MOBILE';

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         companyIds: selectedOptions ?? [],
      }));
   }, []);

   const dbName = localStorage.getItem('dbName');

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   return (
      <Modal
         isOpen={isOpen}
         onClose={handleOnClose}
         size="6xl"
         scrollBehavior="inside"
         overflowY="scroll"
         initialFocusRef={nameInputRef}>
         <ModalOverlay />
         <ModalContent
            bg={useColorModeValue('white', '#2d3748')}
            color={useColorModeValue('gray.800', 'white')}
            borderRadius="20px"
            p={0}
            mx="15px"
            boxShadow="lg">
            <ModalHeader
               className={`
    text-xl font-bold mb-0 xl:mb-4 relative
    ${
       isDark
          ? 'bg-gradient-to-br from-slate-900/95 via-slate-800/90 to-slate-900/95 border-b-2 border-slate-700/60 text-white shadow-xl shadow-black/30'
          : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 border-b-2 border-blue-200/50 text-slate-800 shadow-lg shadow-blue-100/50'
    }
    transition-all duration-300 ease-in-out backdrop-blur-sm
    px-6 py-5 rounded-t-xl
  `}>
               <div className="flex items-center gap-3">
                  {/* Decorative Icon */}
                  <div
                     className={`
      p-2 rounded-lg transition-all duration-300
      ${
         isDark
            ? 'bg-gradient-to-br from-indigo-600/20 to-purple-600/20 border border-indigo-500/30'
            : 'bg-gradient-to-br from-blue-100 to-indigo-100 border border-blue-300/50'
      }
    `}>
                     <svg
                        className={`w-5 h-5 ${isDark ? 'text-indigo-400' : 'text-blue-600'}`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24">
                        {isEditMode ? (
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                           />
                        ) : (
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        )}
                     </svg>
                  </div>

                  {/* Title with gradient text */}
                  <span
                     className={`
      bg-clip-text text-transparent bg-gradient-to-r
      ${isDark ? 'from-white via-blue-100 to-indigo-200' : 'from-slate-800 via-blue-700 to-indigo-700'}
    `}>
                     {isEditMode ? 'Edit Item' : 'Add New Item'}
                  </span>
               </div>
            </ModalHeader>

            <ModalCloseButton
               className={`
    group absolute top-5 right-5 z-10
    p-2.5 rounded-xl transition-all duration-300 ease-in-out
    ${
       isDark
          ? 'text-slate-400 bg-slate-800/50 border-2 border-slate-700/50 hover:text-white hover:bg-gradient-to-br hover:from-red-950/60 hover:to-rose-950/60 hover:border-red-500/60 hover:shadow-lg hover:shadow-red-500/20'
          : 'text-slate-500 bg-white border-2 border-slate-200/60 hover:text-red-700 hover:bg-gradient-to-br hover:from-red-50 hover:to-rose-50 hover:border-red-400/60 hover:shadow-lg hover:shadow-red-200/40'
    }
    hover:scale-110 hover:-rotate-90 active:scale-95
    focus:outline-none focus:ring-4 focus:ring-red-500/30
    backdrop-blur-sm
  `}>
               <svg
                  className="w-4 h-4 transition-transform group-hover:rotate-180"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
               </svg>
            </ModalCloseButton>
            <ModalBody>
               {isLoading ? (
                  <Loading />
               ) : (
                  <Grid h="auto" templateColumns="repeat(5, 1fr)" gap={4} display="block">
                     <GridItem rowSpan={2} colSpan={1}>
                        <div
                           className={`
                                               flex overflow-x-auto px-2 md:px-5 xl:px-5 py-3 md:py-3 xl:py-3 mb-3 md:mb-5 xl:mb-5
                                               border rounded-lg transition-all duration-300
                                               ${
                                                  isDark
                                                     ? 'border-gray-700 bg-gray-800 shadow-xl'
                                                     : 'border-gray-200 bg-white shadow-md'
                                               }
                                             `}>
                           <div className="flex w-full items-center justify-between space-x-1 md:space-x-2">
                              {steps.map((step, index) => (
                                 <div key={index} className="flex flex-1 items-center">
                                    {/* Step Item */}
                                    <div
                                       onClick={() => setActiveStep(index)}
                                       className={`
                                                         flex flex-col items-center cursor-pointer transition-all duration-300 flex-1
                                                         ${activeStep === index ? 'scale-105' : 'scale-100'}
                                                       `}>
                                       {/* Step Indicator */}
                                       <div
                                          className={`
                                                         flex items-center justify-center rounded-full transition-all duration-300 mb-2
                                                         ${
                                                            activeStep === index
                                                               ? 'ring-4 ring-opacity-50 transform scale-110'
                                                               : ''
                                                         }
                                                         ${
                                                            index < activeStep
                                                               ? isDark
                                                                  ? 'bg-gradient-to-r from-green-500 to-teal-500 text-white'
                                                                  : 'bg-gradient-to-r from-green-400 to-teal-400 text-white'
                                                               : activeStep === index
                                                               ? isDark
                                                                  ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white ring-blue-500'
                                                                  : 'bg-gradient-to-r from-blue-400 to-purple-400 text-white ring-blue-400'
                                                               : isDark
                                                               ? 'bg-gray-700 text-gray-300 border border-gray-600'
                                                               : 'bg-gray-100 text-gray-600 border border-gray-300'
                                                         }
                                                         w-5 h-5 md:w-6 md:h-6 xl:w-8 xl:h-8
                                                       `}>
                                          {index < activeStep ? (
                                             <svg
                                                className="w-3 h-3 md:w-4 md:h-4 xl:w-5 xl:h-5"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24">
                                                <path
                                                   strokeLinecap="round"
                                                   strokeLinejoin="round"
                                                   strokeWidth={3}
                                                   d="M5 13l4 4L19 7"
                                                />
                                             </svg>
                                          ) : (
                                             <span
                                                className={`
                                                             font-semibold
                                                             text-xs md:text-sm xl:text-base
                                                             ${activeStep === index ? 'text-white' : ''}
                                                           `}>
                                                {index + 1}
                                             </span>
                                          )}
                                       </div>

                                       {/* Step Title */}
                                       <div
                                          className={`
                                                         text-center transition-all duration-300 font-medium
                                                         ${
                                                            activeStep === index
                                                               ? isDark
                                                                  ? 'text-blue-300 font-bold'
                                                                  : 'text-blue-600 font-bold'
                                                               : isDark
                                                               ? 'text-gray-400'
                                                               : 'text-gray-500'
                                                         }
                                                         text-xs md:text-sm xl:text-sm
                                                         ${activeStep === index ? 'scale-110' : 'scale-100'}
                                                       `}>
                                          {step.title}
                                       </div>
                                    </div>

                                    {/* Step Separator */}
                                    {index < steps.length - 1 && (
                                       <div
                                          className={`
                                                         flex-1 h-0.5 mx-2 transition-all duration-500
                                                         ${
                                                            index < activeStep
                                                               ? isDark
                                                                  ? 'bg-gradient-to-r from-green-500 to-teal-500'
                                                                  : 'bg-gradient-to-r from-green-400 to-teal-400'
                                                               : isDark
                                                               ? 'bg-gray-700'
                                                               : 'bg-gray-300'
                                                         }
                                                         ${index === activeStep - 1 ? 'scale-110' : 'scale-100'}
                                                       `}
                                       />
                                    )}
                                 </div>
                              ))}
                           </div>
                        </div>
                     </GridItem>
                     <GridItem colSpan={4}>
                        {/* <Box mb={5}>
                <Heading>
                  {steps.find((x) => x.step === activeStep)?.title}
                </Heading>
              </Box> */}
                        <Grid
                           templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)', xl: 'repeat(3, 1fr)' }}
                           gap={2}>
                           <>
                              {activeStep === 0 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'name',
                                          'Name',
                                          {
                                             value: row.name,
                                             onChange: handleNameInputChange,
                                             onBlur: handleNameInputBlur,
                                             disabled: isEditMode && isAbs,
                                             ref: nameInputRef,
                                             nextRef: itemdetailtypeRef,
                                             onParse: handleParseProductName,
                                             tabIndex: 0,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      // First field - no backward navigation
                                                      return;
                                                   } else {
                                                      itemdetailtypeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   itemdetailtypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          true,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'itemdetailtype',
                                          'Item Details Type',
                                          ITEM_DETAILS_TYPES,
                                          {
                                             value: row.itemdetailtype,
                                             onChange: (value) => handleInputChange('itemdetailtype', value),
                                             disabled: isEditMode && isAbs,
                                             ref: itemdetailtypeRef,
                                             nextRef: isMobileBusiness ? SeriesRef : categoryRef,
                                             prevRef: nameInputRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      nameInputRef.current?.focus();
                                                   } else {
                                                      if (isMobileBusiness) {
                                                         SeriesRef.current?.focus();
                                                      } else {
                                                         categoryRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Item Details Types',
                                       )}
                                    </GridItem>

                                    {/* Mobile Business Fields */}
                                    {isMobileBusiness && (
                                       <>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'seriesId',
                                                'Series',
                                                seriesOptions,
                                                {
                                                   value: row.seriesId,
                                                   onChange: (value) => handleInputChange('seriesId', value),
                                                   showCustomNoOptions: true,
                                                   openfrom: 'series',
                                                   ref: SeriesRef,
                                                   nextRef: colorRef,
                                                   prevRef: itemdetailtypeRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            itemdetailtypeRef.current?.focus();
                                                         } else {
                                                            colorRef.current?.focus();
                                                         }
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Series',
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'colorId',
                                                'Color',
                                                colorData,
                                                {
                                                   value: row.colorId,
                                                   onChange: (value) => handleInputChange('colorId', value),
                                                   showCustomNoOptions: true,
                                                   openfrom: 'color',
                                                   ref: colorRef,
                                                   nextRef: ramRef,
                                                   prevRef: SeriesRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            SeriesRef.current?.focus();
                                                         } else {
                                                            ramRef.current?.focus();
                                                         }
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Color',
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'ram',
                                                'RAM',
                                                RAM_TYPE,
                                                {
                                                   value: row.ram,
                                                   onChange: (value) => handleInputChange('ram', value),
                                                   ref: ramRef,
                                                   nextRef: storageRef,
                                                   prevRef: colorRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            colorRef.current?.focus();
                                                         } else {
                                                            storageRef.current?.focus();
                                                         }
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select RAM',
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'storage',
                                                'Storage',
                                                STORAGE_TYPE,
                                                {
                                                   value: row.storage,
                                                   onChange: (value) => handleInputChange('storage', value),
                                                   ref: storageRef,
                                                   nextRef: categoryRef,
                                                   prevRef: ramRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            ramRef.current?.focus();
                                                         } else {
                                                            categoryRef.current?.focus();
                                                         }
                                                      } else if (e.key === 'Enter') {
                                                         e.preventDefault();
                                                         categoryRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select Storage',
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'categoryid',
                                                'Category',
                                                categoryData,
                                                {
                                                   value: row.categoryid,
                                                   onChange: (value) => handleInputChange('categoryid', value),
                                                   ref: categoryRef,
                                                   nextRef: shortnameRef,
                                                   prevRef: storageRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            storageRef.current?.focus();
                                                         } else {
                                                            shortnameRef.current?.focus();
                                                         }
                                                      } else if (e.key === 'Enter') {
                                                         e.preventDefault();
                                                         shortnameRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select category',
                                             )}
                                          </GridItem>
                                       </>
                                    )}

                                    {/* Category field for non-mobile business */}
                                    {!isMobileBusiness && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'categoryid',
                                             'Category',
                                             categoryData,
                                             {
                                                value: row.categoryid,
                                                onChange: (value) => handleInputChange('categoryid', value),
                                                ref: categoryRef,
                                                nextRef: shortnameRef,
                                                prevRef: itemdetailtypeRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         itemdetailtypeRef.current?.focus();
                                                      } else {
                                                         shortnameRef.current?.focus();
                                                      }
                                                   } else if (e.key === 'Enter') {
                                                      e.preventDefault();
                                                      shortnameRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select category',
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'shortname',
                                          'Short Name',
                                          {
                                             value: row.shortname,
                                             onChange: (e) => handleInputChange('shortname', e.target.value),
                                             ref: shortnameRef,
                                             nextRef: aliasnameRef,
                                             prevRef: categoryRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      categoryRef.current?.focus();
                                                   } else {
                                                      aliasnameRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   aliasnameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'aliasname',
                                          'Alias Name',
                                          {
                                             value: row.aliasname,
                                             onChange: (e) => handleInputChange('aliasname', e.target.value),
                                             ref: aliasnameRef,
                                             nextRef: printnameRef,
                                             prevRef: shortnameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      shortnameRef.current?.focus();
                                                   } else {
                                                      printnameRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   printnameRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'printname',
                                          'Print Name',
                                          {
                                             value: row.printname,
                                             onChange: (e) => handleInputChange('printname', e.target.value),
                                             ref: printnameRef,
                                             nextRef: codeRef,
                                             prevRef: aliasnameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      aliasnameRef.current?.focus();
                                                   } else {
                                                      codeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   codeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'code',
                                          'Code',
                                          {
                                             value: row.code,
                                             onChange: (e) => handleInputChange('code', e.target.value),
                                             ref: codeRef,
                                             nextRef: itemtypeRef,
                                             prevRef: printnameRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      printnameRef.current?.focus();
                                                   } else {
                                                      itemtypeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   itemtypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'itemtype',
                                          'Item Type',
                                          ITEM_TYPES,
                                          {
                                             value: row.itemtype,
                                             onChange: (value) => handleInputChange('itemtype', value),
                                             ref: itemtypeRef,
                                             nextRef: openingStock1Ref,
                                             prevRef: codeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      codeRef.current?.focus();
                                                   } else {
                                                      openingStock1Ref.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   openingStock1Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Item Type',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'openingStock1',
                                          'Opening Stock 1',
                                          {
                                             value: row.openingStock1,
                                             onChange: (e) => handleInputChange('openingStock1', e.target.value),
                                             ref: openingStock1Ref,
                                             nextRef: itemgroupeRef,
                                             prevRef: itemtypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      itemtypeRef.current?.focus();
                                                   } else {
                                                      itemgroupeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   itemgroupeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'itemgroupid',
                                          'Item Group',
                                          itemGroupData,
                                          {
                                             value: row.itemgroupid,
                                             onChange: (value) => handleInputChange('itemgroupid', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'itemgroups',
                                             ref: itemgroupeRef,
                                             nextRef: applyGST ? hsnRef : uqcRef,
                                             prevRef: openingStock1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      openingStock1Ref.current?.focus();
                                                   } else {
                                                      if (applyGST) {
                                                         hsnRef.current?.focus();
                                                      } else if (company?.setting?.maxUOM >= 1) {
                                                         uqcRef.current?.focus();
                                                      } else {
                                                         ratepersalesRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Item Group',
                                       )}
                                    </GridItem>

                                    {applyGST && (
                                       <>
                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'hsnid',
                                                'HSN',
                                                hsnData?.map((e) => ({ ...e, id: e.id, name: e.hsn })),
                                                {
                                                   value: row.hsnid,
                                                   onChange: (value) => handleInputChange('hsnid', value),
                                                   showCustomNoOptions: true,
                                                   openfrom: 'hsn',
                                                   ref: hsnRef,
                                                   nextRef: sacRef,
                                                   prevRef: itemgroupeRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            itemgroupeRef.current?.focus();
                                                         } else {
                                                            sacRef.current?.focus();
                                                         }
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select HSN',
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {renderDynamicDropdown(
                                                'sacid',
                                                'SAC',
                                                sacData?.map((e) => ({ ...e, id: e.id, name: e.hsn })),
                                                {
                                                   value: row.sacid,
                                                   onChange: (value) => handleInputChange('sacid', value),
                                                   showCustomNoOptions: true,
                                                   openfrom: 'hsn',
                                                   ref: sacRef,
                                                   nextRef: company?.setting?.maxUOM >= 1 ? uqcRef : ratepersalesRef,
                                                   prevRef: hsnRef,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Tab') {
                                                         e.preventDefault();
                                                         if (e.shiftKey) {
                                                            hsnRef.current?.focus();
                                                         } else {
                                                            if (company?.setting?.maxUOM >= 1) {
                                                               uqcRef.current?.focus();
                                                            } else {
                                                               ratepersalesRef.current?.focus();
                                                            }
                                                         }
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                false,
                                                'Select SAC',
                                             )}
                                          </GridItem>
                                       </>
                                    )}

                                    {company?.setting?.maxUOM >= 1 && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'uqcid1',
                                             'Unit 1',
                                             removeDuplicates(uqc, 'name'),
                                             {
                                                value: row.uqcid1,
                                                onChange: (value) => handleInputChange('uqcid1', value),
                                                ref: uqcRef,
                                                nextRef: company?.setting?.maxUOM > 1 ? uqc2Ref : ratepersalesRef,
                                                prevRef: applyGST ? sacRef : itemgroupeRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         if (applyGST) {
                                                            sacRef.current?.focus();
                                                         } else {
                                                            itemgroupeRef.current?.focus();
                                                         }
                                                      } else {
                                                         if (company?.setting?.maxUOM > 1) {
                                                            uqc2Ref.current?.focus();
                                                         } else {
                                                            ratepersalesRef.current?.focus();
                                                         }
                                                      }
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Unit 1',
                                          )}
                                       </GridItem>
                                    )}

                                    {company?.setting?.maxUOM > 1 && company?.setting?.maxUOM <= 3 && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'uqcid2',
                                             'Unit 2',
                                             removeDuplicates(uqc, 'name'),
                                             {
                                                value: row.uqcid2,
                                                onChange: (value) => handleInputChange('uqcid2', value),
                                                ref: uqc2Ref,
                                                nextRef: company?.setting?.maxUOM > 2 ? uqc3Ref : ratepersalesRef,
                                                prevRef: uqcRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         uqcRef.current?.focus();
                                                      } else {
                                                         if (company?.setting?.maxUOM > 2) {
                                                            uqc3Ref.current?.focus();
                                                         } else {
                                                            ratepersalesRef.current?.focus();
                                                         }
                                                      }
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Unit 2',
                                          )}
                                       </GridItem>
                                    )}

                                    {company?.setting?.maxUOM > 2 && company?.setting?.maxUOM <= 3 && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'uqcid3',
                                             'Unit 3',
                                             removeDuplicates(uqc, 'name'),
                                             {
                                                value: row.uqcid3,
                                                onChange: (value) => handleInputChange('uqcid3', value),
                                                ref: uqc3Ref,
                                                nextRef: ratepersalesRef,
                                                prevRef: uqc2Ref,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         uqc2Ref.current?.focus();
                                                      } else {
                                                         ratepersalesRef.current?.focus();
                                                      }
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false,
                                             'Select Unit 3',
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'ratepersalesid',
                                          'Rate Per Sale',
                                          removeDuplicates(ratePerSalesOptions, 'name'),
                                          {
                                             value: row.ratepersalesid,
                                             onChange: (value) => handleInputChange('ratepersalesid', value),
                                             ref: ratepersalesRef,
                                             nextRef: rateperpurchaseRef,
                                             prevRef: (() => {
                                                if (company?.setting?.maxUOM > 2) return uqc3Ref;
                                                if (company?.setting?.maxUOM > 1) return uqc2Ref;
                                                if (company?.setting?.maxUOM >= 1) return uqcRef;
                                                if (applyGST) return sacRef;
                                                return itemgroupeRef;
                                             })(),
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      if (company?.setting?.maxUOM > 2) {
                                                         uqc3Ref.current?.focus();
                                                      } else if (company?.setting?.maxUOM > 1) {
                                                         uqc2Ref.current?.focus();
                                                      } else if (company?.setting?.maxUOM >= 1) {
                                                         uqcRef.current?.focus();
                                                      } else if (applyGST) {
                                                         sacRef.current?.focus();
                                                      } else {
                                                         itemgroupeRef.current?.focus();
                                                      }
                                                   } else {
                                                      rateperpurchaseRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Rate Per Sales',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'rateperpurchaseid',
                                          'Rate Per Purchase',
                                          removeDuplicates(ratePerSalesOptions, 'name'),
                                          {
                                             value: row.rateperpurchaseid,
                                             onChange: (value) => handleInputChange('rateperpurchaseid', value),
                                             ref: rateperpurchaseRef,
                                             nextRef: primaryuqcRef,
                                             prevRef: ratepersalesRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      ratepersalesRef.current?.focus();
                                                   } else {
                                                      primaryuqcRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Rate Per Purchase',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'primaryuqcid',
                                          'Primary UQC',
                                          removeDuplicates(ratePerSalesOptions, 'name'),
                                          {
                                             value: row.primaryuqcid,
                                             onChange: (value) => handleInputChange('primaryuqcid', value),
                                             ref: primaryuqcRef,
                                             nextRef: parentRef,
                                             prevRef: rateperpurchaseRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      rateperpurchaseRef.current?.focus();
                                                   } else {
                                                      parentRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Primary UQC',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'parentid',
                                          'Parent Item',
                                          itemData,
                                          {
                                             value: row.parentid,
                                             onChange: (value) => handleInputChange('parentid', value),
                                             ref: parentRef,
                                             nextRef: vendorRef,
                                             prevRef: primaryuqcRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      primaryuqcRef.current?.focus();
                                                   } else {
                                                      vendorRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Parent Item',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'vendorid',
                                          'Vendor',
                                          vendorData,
                                          {
                                             value: row.vendorid,
                                             onChange: (value) => handleInputChange('vendorid', value),
                                             showCustomNoOptions: true,
                                             openfrom: 'account',
                                             ref: vendorRef,
                                             nextRef: shouldSendCompanyidItem ? companyRef : imageRef,
                                             prevRef: parentRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      parentRef.current?.focus();
                                                   } else {
                                                      if (shouldSendCompanyidItem) {
                                                         companyRef.current?.focus();
                                                      } else {
                                                         imageRef.current?.focus();
                                                      }
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Vendor',
                                       )}
                                    </GridItem>

                                    {shouldSendCompanyidItem && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicUiDropdown(
                                             'company',
                                             'Company',
                                             lastcompanyOptions,
                                             {
                                                value: row.companyIds,
                                                onChange: handleCompanyChange,
                                                ref: companyRef,
                                                nextRef: imageRef,
                                                prevRef: vendorRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         vendorRef.current?.focus();
                                                      } else {
                                                         imageRef.current?.focus();
                                                      }
                                                   }
                                                },
                                             },
                                             {},
                                             textColor,
                                             false,
                                             'Select company',
                                             true,
                                             undefined,
                                             true,
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width">
                                       <FormControl
                                          isInvalid={!!errors.image}
                                          mb="24px"
                                          display="flex"
                                          alignItems="center">
                                          <FormLabel fontSize="sm" fontWeight="500" color={textColor} mr={9}>
                                             Image
                                          </FormLabel>

                                          <Input
                                             type="file"
                                             ref={imageRef}
                                             accept=".png, .jpeg, .jpg"
                                             alignContent="center"
                                             variant="auth"
                                             size="lg"
                                             _focus={{ outlineColor: 'blue.500' }}
                                             onChange={(e) => handleFileChange(e)}
                                             onKeyDown={(e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      if (shouldSendCompanyidItem) {
                                                         companyRef.current?.focus();
                                                      } else {
                                                         vendorRef.current?.focus();
                                                      }
                                                   } else {
                                                      savefinishRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   savefinishRef.current?.focus();
                                                }
                                             }}
                                          />

                                          {errors.image && (
                                             <Text color="red.500" fontSize="sm" mt="2">
                                                {errors.image.message}
                                             </Text>
                                          )}
                                       </FormControl>
                                    </GridItem>
                                 </>
                              )}

                              {activeStep === 1 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'mrp',
                                          'MRP',
                                          {
                                             value: row.mrp,
                                             onChange: (e) => handleInputChange('mrp', e.target.value),
                                             ref: mrpRef,
                                             nextRef: actiononminmaxpriceRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      // First field - no backward navigation
                                                      return;
                                                   } else {
                                                      actiononminmaxpriceRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   actiononminmaxpriceRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'actiononminmaxprice',
                                          'Action On Min Max Price',
                                          ACTION_TYPE,
                                          {
                                             value: row.actiononminmaxprice,
                                             onChange: (value) => handleInputChange('actiononminmaxprice', value),
                                             ref: actiononminmaxpriceRef,
                                             nextRef: defaultsellingqtyRef,
                                             prevRef: mrpRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      mrpRef.current?.focus();
                                                   } else {
                                                      defaultsellingqtyRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   defaultsellingqtyRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Action On Min Max Price',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'defaultsellingqty',
                                          'Default Selling Qty',
                                          {
                                             value: row.defaultsellingqty,
                                             onChange: (e) => handleInputChange('defaultsellingqty', e.target.value),
                                             ref: defaultsellingqtyRef,
                                             nextRef: salesbrokeragetypeRef,
                                             prevRef: actiononminmaxpriceRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      actiononminmaxpriceRef.current?.focus();
                                                   } else {
                                                      salesbrokeragetypeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salesbrokeragetypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'salesbrokeragetype',
                                          'Sales Brokerage Type',
                                          BROKERAGE_TYPES,
                                          {
                                             value: row.salesbrokeragetype,
                                             onChange: (value) => handleInputChange('salesbrokeragetype', value),
                                             ref: salesbrokeragetypeRef,
                                             nextRef: salesbrokerageRef,
                                             prevRef: defaultsellingqtyRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      defaultsellingqtyRef.current?.focus();
                                                   } else {
                                                      salesbrokerageRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salesbrokerageRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Sales Brokerage Type',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salesbrokerage',
                                          'Sales Brokerage',
                                          {
                                             value: row.salesbrokerage,
                                             onChange: (e) => handleInputChange('salesbrokerage', e.target.value),
                                             ref: salesbrokerageRef,
                                             nextRef: purchasepriceRef,
                                             prevRef: salesbrokeragetypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salesbrokeragetypeRef.current?.focus();
                                                   } else {
                                                      purchasepriceRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   purchasepriceRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchaseprice',
                                          'Purchase Price',
                                          {
                                             value: row.purchaseprice,
                                             onChange: (e) => handleInputChange('purchaseprice', e.target.value),
                                             ref: purchasepriceRef,
                                             nextRef: purchasecostperRef,
                                             prevRef: salesbrokerageRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salesbrokerageRef.current?.focus();
                                                   } else {
                                                      purchasecostperRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   purchasecostperRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchasecostper',
                                          'Purchase Cost Per',
                                          {
                                             value: row.purchasecostper,
                                             onChange: (e) => handleInputChange('purchasecostper', e.target.value),
                                             ref: purchasecostperRef,
                                             nextRef: purchasebrokeragetypeRef,
                                             prevRef: purchasepriceRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      purchasepriceRef.current?.focus();
                                                   } else {
                                                      purchasebrokeragetypeRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   purchasebrokeragetypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'purchasebrokeragetype',
                                          'Purchase Brokerage Type',
                                          BROKERAGE_TYPES,
                                          {
                                             value: row.purchasebrokeragetype,
                                             onChange: (value) => handleInputChange('purchasebrokeragetype', value),
                                             ref: purchasebrokeragetypeRef,
                                             nextRef: purchasebrokerageRef,
                                             prevRef: purchasecostperRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      purchasecostperRef.current?.focus();
                                                   } else {
                                                      purchasebrokerageRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   purchasebrokerageRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Purchase Brokerage Type',
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchasebrokerage',
                                          'Purchase brokerage',
                                          {
                                             value: row.purchasebrokerage,
                                             onChange: (e) => handleInputChange('purchasebrokerage', e.target.value),
                                             ref: purchasebrokerageRef,
                                             nextRef: maxsalespriceRef,
                                             prevRef: purchasebrokeragetypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      purchasebrokeragetypeRef.current?.focus();
                                                   } else {
                                                      maxsalespriceRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   maxsalespriceRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'maxsalesprice',
                                          'Max Sales Price',
                                          {
                                             value: row.maxsalesprice,
                                             onChange: (e) => handleInputChange('maxsalesprice', e.target.value),
                                             ref: maxsalespriceRef,
                                             nextRef: salesprice1Ref,
                                             prevRef: purchasebrokerageRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      purchasebrokerageRef.current?.focus();
                                                   } else {
                                                      salesprice1Ref.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salesprice1Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salesprice1',
                                          'Sales Price 1',
                                          {
                                             value: row.salesprice1,
                                             onChange: (e) => handleInputChange('salesprice1', e.target.value),
                                             ref: salesprice1Ref,
                                             nextRef: salesprice2Ref,
                                             prevRef: maxsalespriceRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      maxsalespriceRef.current?.focus();
                                                   } else {
                                                      salesprice2Ref.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salesprice2Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salesprice2',
                                          'Sales Price 2',
                                          {
                                             value: row.salesprice2,
                                             onChange: (e) => handleInputChange('salesprice2', e.target.value),
                                             ref: salesprice2Ref,
                                             nextRef: salesprice3Ref,
                                             prevRef: salesprice1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salesprice1Ref.current?.focus();
                                                   } else {
                                                      salesprice3Ref.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salesprice3Ref.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salesprice3',
                                          'Sales Price 3',
                                          {
                                             value: row.salesprice3,
                                             onChange: (e) => handleInputChange('salesprice3', e.target.value),
                                             ref: salesprice3Ref,
                                             nextRef: minsalespriceRef,
                                             prevRef: salesprice2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salesprice2Ref.current?.focus();
                                                   } else {
                                                      minsalespriceRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   minsalespriceRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'minsalesprice',
                                          'Min Sales Price',
                                          {
                                             value: row.minsalesprice,
                                             onChange: (e) => handleInputChange('minsalesprice', e.target.value),
                                             ref: minsalespriceRef,
                                             nextRef: salespriceperRef,
                                             prevRef: salesprice3Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salesprice3Ref.current?.focus();
                                                   } else {
                                                      salespriceperRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   salespriceperRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'salespriceper',
                                          'Sales Price Per',
                                          {
                                             value: row.salespriceper,
                                             onChange: (e) => handleInputChange('salespriceper', e.target.value),
                                             ref: salespriceperRef,
                                             nextRef: warnabovemaxlvlRef,
                                             prevRef: minsalespriceRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      minsalespriceRef.current?.focus();
                                                   } else {
                                                      warnabovemaxlvlRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   warnabovemaxlvlRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'warnabovemaxlvl',
                                          'Warn Above Max Level',
                                          ACTION_TYPE,
                                          {
                                             value: row.warnabovemaxlvl,
                                             onChange: (value) => handleInputChange('warnabovemaxlvl', value),
                                             ref: warnabovemaxlvlRef,
                                             nextRef: Textile ? defaultcutRef : nameinotherlanguageRef,
                                             prevRef: salespriceperRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      salespriceperRef.current?.focus();
                                                   } else {
                                                      if (Textile) {
                                                         defaultcutRef.current?.focus();
                                                      } else {
                                                         nameinotherlanguageRef.current?.focus();
                                                      }
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   if (Textile) {
                                                      defaultcutRef.current?.focus();
                                                   } else {
                                                      nameinotherlanguageRef.current?.focus();
                                                   }
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false,
                                          'Select Action Type',
                                       )}
                                    </GridItem>

                                    {Textile && (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'defaultcut',
                                             'Default Cut',
                                             {
                                                value: row.defaultcut,
                                                onChange: (e) => handleInputChange('defaultcut', e.target.value),
                                                ref: defaultcutRef,
                                                nextRef: nameinotherlanguageRef,
                                                prevRef: warnabovemaxlvlRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Tab') {
                                                      e.preventDefault();
                                                      if (e.shiftKey) {
                                                         warnabovemaxlvlRef.current?.focus();
                                                      } else {
                                                         nameinotherlanguageRef.current?.focus();
                                                      }
                                                   } else if (e.key === 'Enter') {
                                                      e.preventDefault();
                                                      nameinotherlanguageRef.current?.focus();
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             'number',
                                             false,
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'nameinotherlanguage',
                                          'Name In Other Language',
                                          {
                                             value: row.nameinotherlanguage,
                                             onChange: (e) => handleInputChange('nameinotherlanguage', e.target.value),
                                             ref: nameinotherlanguageRef,
                                             nextRef: additioninsalespriceRef,
                                             prevRef: Textile ? defaultcutRef : warnabovemaxlvlRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      if (Textile) {
                                                         defaultcutRef.current?.focus();
                                                      } else {
                                                         warnabovemaxlvlRef.current?.focus();
                                                      }
                                                   } else {
                                                      additioninsalespriceRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   additioninsalespriceRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'additioninsalesprice',
                                          'Addition In Sales Price',
                                          {
                                             value: row.additioninsalesprice,
                                             onChange: (e) => handleInputChange('additioninsalesprice', e.target.value),
                                             ref: additioninsalespriceRef,
                                             nextRef: savefinishRef,
                                             prevRef: nameinotherlanguageRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Tab') {
                                                   e.preventDefault();
                                                   if (e.shiftKey) {
                                                      nameinotherlanguageRef.current?.focus();
                                                   } else {
                                                      savefinishRef.current?.focus();
                                                   }
                                                } else if (e.key === 'Enter') {
                                                   e.preventDefault();
                                                   savefinishRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )}

                              {activeStep === 2 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'warnbelowreorder',
                                          'Warn Below Reorder',
                                          ACTION_TYPE,
                                          {
                                             value: row.warnbelowreorder,
                                             onChange: (value) => handleInputChange('warnbelowreorder', value),
                                             ref: warnbelowreorderRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   stocknegativeactionRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          false, // isRequired
                                          'Select Action Type', // placeholder
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'stocknegativeaction',
                                          'Stock Negative Action',
                                          ACTION_TYPE,
                                          {
                                             value: row.stocknegativeaction,
                                             onChange: (value) => handleInputChange('stocknegativeaction', value),
                                             ref: stocknegativeactionRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   wholesalerateRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          false, // isRequired

                                          'Select Action Type', // placeholder
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'wholesalerate',
                                          'Wholesale Rate',
                                          {
                                             value: row.wholesalerate,
                                             onChange: (e) => handleInputChange('wholesalerate', e.target.value),
                                             ref: wholesalerateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   stockrateRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'stockrate',
                                          'Stock Rate',
                                          {
                                             value: row.stockrate,
                                             onChange: (e) => handleInputChange('stockrate', e.target.value),
                                             ref: stockrateRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   minlevelRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'minlevel',
                                          'Minimum Level',
                                          {
                                             value: row.minlevel,
                                             onChange: (e) => handleInputChange('minlevel', e.target.value),
                                             ref: minlevelRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   warnbelowminlvlRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    {/* <GridItem>
                        {renderSwitchControl(
                          'warnbelowminlvl',
                          'Warn If Below Minimum Level',
                          {
                            isChecked: row.warnbelowminlvl,
                            onChange: handleSwitchChange('warnbelowminlvl'), // Pass field name dynamically
                          },
                          errors,
                          'gray.700',
                          false, // Not required
                          false, // Not disabled
                        )}
                      </GridItem> */}

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'warnbelowminlvl',
                                          'Warn If Below Minimum Level',
                                          ACTION_TYPE,
                                          {
                                             value: row.warnbelowminlvl,
                                             onChange: (value) => handleInputChange('warnbelowminlvl', value),
                                             ref: warnbelowminlvlRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   maxlevelRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false, // isRequired
                                          'Select Action Type', // placeholder
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'maxlevel',
                                          'Max Level',
                                          {
                                             value: row.maxlevel,
                                             onChange: (e) => handleInputChange('maxlevel', e.target.value),
                                             ref: maxlevelRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   reorderlevelRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'reorderlevel',
                                          'Reorder Level',
                                          {
                                             value: row.reorderlevel,
                                             onChange: (e) => handleInputChange('reorderlevel', e.target.value),
                                             ref: reorderlevelRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   reorderquantityRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'reorderquantity',
                                          'Reorder Quantity',
                                          {
                                             value: row.reorderquantity,
                                             onChange: (e) => handleInputChange('reorderquantity', e.target.value),
                                             ref: reorderquantityRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   saleDiscPerRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    {/* <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'balancequantity1',
                                          'Balance Quantity 1',
                                          {
                                             value: row.balancequantity1,
                                             onChange: (e) => handleInputChange('balancequantity1', e.target.value),
                                             ref: balancequantity1Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   balancequantity2Ref.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'balancequantity2',
                                          'Balance Quantity 2',
                                          {
                                             value: row.balancequantity2,

                                             onChange: (e) => handleInputChange('balancequantity2', e.target.value),
                                             ref: balancequantity2Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   balancequantity3Ref.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'balancequantity3',
                                          'Balance Quantity 3',
                                          {
                                             value: row.balancequantity3,

                                             onChange: (e) => handleInputChange('balancequantity3', e.target.value),
                                             ref: balancequantity3Ref,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   foldpercentageRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem> */}

                                    {Textile && (
                                       <GridItem className="seperator-width">
                                          {DynamicInput(
                                             'foldpercentage',
                                             'Fold Percentage',
                                             {
                                                value: row.foldpercentage,

                                                onChange: (e) => handleInputChange('foldpercentage', e.target.value),
                                                ref: foldpercentageRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      saleDiscPerRef.current?.focus();
                                                   }
                                                },
                                             },

                                             errors,
                                             textColor,
                                             'number',
                                             false,
                                          )}
                                       </GridItem>
                                    )}

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'saleDiscPer',
                                          'Sale Discount Percentage',
                                          {
                                             value: row.saleDiscPer,

                                             onChange: (e) => handleInputChange('saleDiscPer', e.target.value),
                                             ref: saleDiscPerRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   saleDiscAmtRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'saleDiscAmt',
                                          'Sale Discount Amount',
                                          {
                                             value: row.saleDiscAmt,
                                             onChange: (e) => handleInputChange('saleDiscAmt', e.target.value),
                                             ref: saleDiscAmtRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   purchaseDiscPerRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchaseDiscPer',
                                          'Purchase Discount Percentage',
                                          {
                                             value: row.purchaseDiscPer,
                                             onChange: (e) => handleInputChange('purchaseDiscPer', e.target.value),
                                             ref: purchaseDiscPerRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   purchaseDisAmtRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'purchaseDisAmt',
                                          'Purchase Discount Amount',
                                          {
                                             value: row.purchaseDisAmt,
                                             onChange: (e) => handleInputChange('purchaseDisAmt', e.target.value),
                                             ref: purchaseDisAmtRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   finishItemRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    {Textile && (
                                       <GridItem className="seperator-width">
                                          {renderDynamicDropdown(
                                             'finishItemId',
                                             'Finish Item',
                                             finishItemData,
                                             {
                                                value: row.finishItemId,
                                                onChange: (value) => handleInputChange('finishItemId', value),
                                                ref: finishItemRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      e.preventDefault();
                                                      savefinishRef.current?.focus();
                                                   }
                                                },
                                             },

                                             errors,
                                             textColor,
                                             false, // isRequired

                                             'Select Finish Item', // placeholder
                                          )}
                                       </GridItem>
                                    )}
                                 </>
                              )}

                              {activeStep === 4 && businessTypes.businessType === 'MOBILE' ? (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'battery',
                                          'Battery (mAh)',
                                          {
                                             value: row.battery,
                                             onChange: (e) => handleInputChange('battery', e.target.value),
                                             ref: batteryRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   displayRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'display',
                                          'Display',
                                          {
                                             value: row.display,
                                             onChange: (e) => handleInputChange('display', e.target.value),
                                             ref: displayRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   displayTypeRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'displayType',
                                          'Display Type',
                                          {
                                             value: row.displayType,
                                             onChange: (e) => handleInputChange('displayType', e.target.value),
                                             ref: displayTypeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   frontCameraRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'frontCamera',
                                          'Front Camera',
                                          {
                                             value: row.frontCamera,
                                             onChange: (e) => handleInputChange('frontCamera', e.target.value),
                                             ref: frontCameraRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   rearCameraRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'rearCamera',
                                          'Rear Camera',
                                          {
                                             value: row.rearCamera,
                                             onChange: (e) => handleInputChange('rearCamera', e.target.value),
                                             ref: rearCameraRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   processorRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'processor',
                                          'Processor',
                                          {
                                             value: row.processor,
                                             onChange: (e) => handleInputChange('processor', e.target.value),
                                             ref: processorRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   mmSizeRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'mmSize',
                                          'MM Size',
                                          {
                                             value: row.mmSize,
                                             onChange: (e) => handleInputChange('mmSize', e.target.value),
                                             ref: mmSizeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   gstRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'gst',
                                          'GST',
                                          {
                                             isChecked: row.gst,
                                             onChange: handleSwitchChange('gst'), // Pass field name dynamically
                                             ref: gstRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   cellularRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false, // Not required
                                          false, // Not disabled
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'cellular',
                                          'Cellular',
                                          {
                                             isChecked: row.cellular,
                                             onChange: handleSwitchChange('cellular'), // Pass field name dynamically
                                             ref: cellularRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   orderRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false, // Not required
                                          false, // Not disabled
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'order',
                                          'Order (1,2, etc.)',
                                          {
                                             value: row.order,
                                             onChange: (e) => handleInputChange('order', e.target.value),
                                             ref: orderRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   networkRef.current?.focus();
                                                }
                                             },
                                          },

                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderDynamicDropdown(
                                          'network',
                                          'Network',
                                          NETWORK_TYPE,
                                          {
                                             value: row.network,
                                             onChange: (value) => handleInputChange('network', value),
                                             ref: networkRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   savefinishRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false, // isRequired
                                          'Select Network', // placeholder
                                       )}
                                    </GridItem>
                                 </>
                              ) : null}

                              {activeStep === 3 && (
                                 <>
                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'barcode',
                                          'Barcode',
                                          {
                                             value: row.barcode,
                                             onChange: (e) => handleInputChange('barcode', e.target.value),
                                             ref: barcodeRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   itemtypeRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {renderSwitchControl(
                                          'isassembly',
                                          'Is Assembly',
                                          {
                                             isChecked: row.isassembly,
                                             onChange: handleSwitchChange('isassembly'), // Pass field name dynamically
                                             ref: isassemblyRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   weightRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          false, // Not required
                                          false, // Not disabled
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'weight',
                                          'Weight',
                                          {
                                             value: row.weight,
                                             onChange: (e) => handleInputChange('weight', e.target.value),
                                             ref: weightRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   lengthRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'length',
                                          'Length',
                                          {
                                             value: row.length,
                                             onChange: (e) => handleInputChange('length', e.target.value),
                                             ref: lengthRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   widthRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'width',
                                          'Width',
                                          {
                                             value: row.width,
                                             onChange: (e) => handleInputChange('width', e.target.value),
                                             ref: widthRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   heightRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'height',
                                          'Height',
                                          {
                                             value: row.height,
                                             onChange: (e) => handleInputChange('height', e.target.value),
                                             ref: heightRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   calculatemtsRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'number',
                                          false,
                                       )}
                                    </GridItem>

                                    {Textile && (
                                       <GridItem className="seperator-width">
                                          {renderSwitchControl(
                                             'calculatemts',
                                             'Calculate Mts',
                                             {
                                                isChecked: row.calculatemts,
                                                onChange: handleSwitchChange('calculatemts'), // Pass field name dynamically
                                                ref: calculatemtsRef,
                                                onKeyDown: (e) => {
                                                   if (e.key === 'Enter' || e.key === 'Tab') {
                                                      if (company && company.setting && company.setting.maxUOM >= 1) {
                                                         e.preventDefault();
                                                         uqcformat1Ref.current?.focus();
                                                      } else if (
                                                         company &&
                                                         company.setting &&
                                                         company.setting.maxUOM > 1 &&
                                                         company.setting.maxUOM <= 3
                                                      ) {
                                                         e.preventDefault();
                                                         uqcformat2Ref.current?.focus();
                                                      }
                                                   }
                                                },
                                             },
                                             errors,
                                             textColor,
                                             false, // Not required
                                             false, // Not disabled
                                          )}
                                       </GridItem>
                                    )}

                                    {/* UQC Format 1 start  */}
                                    {company && company.setting && company.setting.maxUOM >= 1 ? (
                                       <>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'uqcformat1',
                                                'UQC Format 1',
                                                {
                                                   value: row.uqcformat1,
                                                   onChange: (e) => handleInputChange('uqcformat1', e.target.value),
                                                   ref: uqcformat1Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing12Ref.current?.focus();
                                                      }
                                                   },
                                                },

                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing12',
                                                'Packing 12',
                                                {
                                                   value: row.packing12,
                                                   onChange: (e) => handleInputChange('packing12', e.target.value),
                                                   ref: packing12Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing13Ref.current?.focus();
                                                      }
                                                   },
                                                },

                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          {/* <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname12',
                                                'Packing Name 12',
                                                {
                                                   value: row.packingname12,
                                                   onChange: (e) => handleInputChange('packingname12', e.target.value),
                                                   ref: packingname12Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing13Ref.current?.focus();
                                                      }
                                                   },
                                                },

                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem> */}

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing13',
                                                'Packing 13',
                                                {
                                                   value: row.packing13,
                                                   onChange: (e) => handleInputChange('packing13', e.target.value),
                                                   ref: packing13Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         defaultquantity1Ref.current?.focus();
                                                      }
                                                   },
                                                },

                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          {/* <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname13',
                                                'Packing Name 13',
                                                {
                                                   value: row.packingname13,
                                                   onChange: (e) => handleInputChange('packingname13', e.target.value),
                                                   ref: packingname13Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         defaultquantity1Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem> */}

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'defaultquantity1',
                                                'Default Quantity 1',
                                                {
                                                   value: row.defaultquantity1,
                                                   onChange: (e) =>
                                                      handleInputChange('defaultquantity1', e.target.value),
                                                   ref: defaultquantity1Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         openingStock1Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>
                                       </>
                                    ) : null}

                                    {/* UQC Format 1 end  */}

                                    {/* UQC Format 2 start  */}

                                    {company &&
                                    company.setting &&
                                    company.setting.maxUOM > 1 &&
                                    company.setting.maxUOM <= 3 ? (
                                       <>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'uqcformat2',
                                                'UQC Format 2',
                                                {
                                                   value: row.uqcformat2,
                                                   onChange: (e) => handleInputChange('uqcformat2', e.target.value),
                                                   ref: uqcformat2Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing23Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing23',
                                                'Packing 23',
                                                {
                                                   value: row.packing23,
                                                   onChange: (e) => handleInputChange('packing23', e.target.value),
                                                   ref: packing23Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing21Ref.current?.focus();
                                                      }
                                                   },
                                                },

                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          {/* <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname23',
                                                'Packing Name 23',
                                                {
                                                   value: row.packingname23,
                                                   onChange: (e) => handleInputChange('packingname23', e.target.value),
                                                   ref: packingname23Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         packing21Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem> */}

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing21',
                                                'Packing 21',
                                                {
                                                   value: row.packing21,
                                                   onChange: (e) => handleInputChange('packing21', e.target.value),
                                                   ref: packing21Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         openingStock2Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          {/* <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname21',
                                                'Packing Name 21',
                                                {
                                                   value: row.packingname21,
                                                   onChange: (e) => handleInputChange('packingname21', e.target.value),
                                                   ref: packingname21Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         defaultquantity2Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem> */}

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'defaultquantity2',
                                                'Default Quantity 2',
                                                {
                                                   value: row.defaultquantity2,
                                                   onChange: (e) =>
                                                      handleInputChange('defaultquantity2', e.target.value),
                                                   ref: defaultquantity2Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         openingStock2Ref.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'openingStock2',
                                                'Opening Stock 2',
                                                {
                                                   value: row.openingStock2,
                                                   onChange: (e) => handleInputChange('openingStock2', e.target.value),
                                                   ref: openingStock2Ref,
                                                   onKeyDown: (e) => {
                                                      if (e.key === 'Enter' || e.key === 'Tab') {
                                                         e.preventDefault();
                                                         notesRef.current?.focus();
                                                      }
                                                   },
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>
                                       </>
                                    ) : null}

                                    {/* UQC Format 2 end  */}

                                    {/* UQC Format 3 start  */}

                                    {company &&
                                    company.setting &&
                                    company.setting.maxUOM > 2 &&
                                    company.setting.maxUOM <= 3 ? (
                                       <>
                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'uqcformat3',
                                                'UQC Format 3',
                                                {
                                                   value: row.uqcformat3,
                                                   onChange: (e) => handleInputChange('uqcformat3', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing31',
                                                'Packing 31',
                                                {
                                                   value: row.packing31,
                                                   onChange: (e) => handleInputChange('packing31', e.target.value),
                                                },

                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname31',
                                                'Packing Name 31',
                                                {
                                                   value: row.packingname31,
                                                   onChange: (e) => handleInputChange('packingname31', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packing32',
                                                'Packing 32',
                                                {
                                                   value: row.packing32,
                                                   onChange: (e) => handleInputChange('packing32', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'packingname32',
                                                'Packing Name 32',
                                                {
                                                   value: row.packingname32,
                                                   onChange: (e) => handleInputChange('packingname32', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'text',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'defaultquantity3',
                                                'Default Quantity 3',
                                                {
                                                   value: row.defaultquantity3,

                                                   onChange: (e) =>
                                                      handleInputChange('defaultquantity3', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>

                                          <GridItem className="seperator-width">
                                             {DynamicInput(
                                                'openingStock3',
                                                'Opening Stock 3',
                                                {
                                                   value: row.openingStock3,
                                                   onChange: (e) => handleInputChange('openingStock3', e.target.value),
                                                },
                                                errors,
                                                textColor,
                                                'number',
                                                false,
                                             )}
                                          </GridItem>
                                       </>
                                    ) : null}

                                    {/* UQC Format 3 end  */}

                                    <GridItem className="seperator-width">
                                       {DynamicInput(
                                          'notes',
                                          'Notes',
                                          {
                                             value: row.notes,
                                             onChange: (e) => handleInputChange('notes', e.target.value),
                                             ref: notesRef,
                                             onKeyDown: (e) => {
                                                if (e.key === 'Enter' || e.key === 'Tab') {
                                                   e.preventDefault();
                                                   categoryRef.current?.focus();
                                                }
                                             },
                                          },
                                          errors,
                                          textColor,
                                          'text',
                                          false,
                                       )}
                                    </GridItem>
                                 </>
                              )}
                           </>
                        </Grid>
                     </GridItem>
                  </Grid>
               )}
            </ModalBody>
            <ModalFooter
               className={`
    px-6 py-5 border-t rounded-b-xl backdrop-blur-sm
    ${
       isDark
          ? 'bg-gradient-to-br from-slate-900/95 via-slate-800/95 to-slate-900/95 border-slate-700/50 shadow-2xl shadow-black/20'
          : 'bg-gradient-to-br from-white via-slate-50/80 to-white border-slate-200/60 shadow-lg shadow-slate-200/50'
    }
  `}>
               <div className="flex flex-wrap items-center justify-end gap-3 w-full">
                  {/* Previous Button */}
                  {activeStep > 0 && (
                     <button
                        onClick={() => handlePrevious()}
                        variant="ghost"
                        className={`
          group px-6 py-2.5 font-semibold rounded-xl border-2 transition-all duration-300 
          hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0
          ${
             isDark
                ? 'text-slate-300 bg-slate-800/50 border-slate-600/50 hover:bg-slate-700/80 hover:text-white hover:border-indigo-500/60 hover:shadow-indigo-500/20'
                : 'text-slate-700 bg-white border-slate-300/60 hover:bg-gradient-to-br hover:from-blue-50 hover:to-indigo-50 hover:text-blue-700 hover:border-blue-400/60 hover:shadow-blue-200/40'
          }
          focus:outline-none focus:ring-4 focus:ring-blue-500/30
        `}
                        _focus={{ outlineColor: 'blue.500' }}>
                        <div className="flex items-center gap-2">
                           <svg
                              className="w-4 h-4 transition-transform group-hover:-translate-x-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2.5}
                                 d="M15 19l-7-7 7-7"
                              />
                           </svg>
                           Previous
                        </div>
                     </button>
                  )}

                  {/* Next Button */}
                  {activeStep !== steps.length - 1 && (
                     <button
                        ref={nextRef}
                        onClick={() => handleNext()}
                        className={`
          group px-6 py-2.5 font-semibold rounded-xl text-white transition-all duration-300 
          shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0
          ${
             isDark
                ? 'bg-gradient-to-br from-blue-600 via-blue-500 to-indigo-600 hover:from-blue-500 hover:via-blue-600 hover:to-indigo-500 border-2 border-blue-400/30 shadow-blue-500/30 hover:shadow-blue-400/40'
                : 'bg-gradient-to-br from-blue-500 via-blue-600 to-indigo-600 hover:from-blue-600 hover:via-blue-500 hover:to-indigo-500 border-2 border-blue-300/40 shadow-blue-500/30 hover:shadow-blue-500/50'
          }
          focus:outline-none focus:ring-4 focus:ring-blue-500/40
        `}
                        _focus={{ outlineColor: 'blue.500' }}>
                        <div className="flex items-center gap-2">
                           {activeStep === steps.length - 1 ? 'Save' : 'Next'}
                           <svg
                              className="w-4 h-4 transition-transform group-hover:translate-x-1"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                           </svg>
                        </div>
                     </button>
                  )}

                  {/* Save And Continue Button */}
                  {!isEditMode && saveandcontinue === true && (
                     <button
                        type="button"
                        onClick={() => handleSaveAndContinue()}
                        isLoading={isLoadingbt}
                        disabled={isLoadingbt}
                        className={`
          group px-6 py-2.5 font-semibold rounded-xl text-white transition-all duration-300 
          shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0
          disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-md
          ${
             isDark
                ? 'bg-gradient-to-br from-emerald-600 via-green-500 to-teal-600 hover:from-emerald-500 hover:via-green-600 hover:to-teal-500 border-2 border-emerald-400/30 shadow-emerald-500/30 hover:shadow-emerald-400/40'
                : 'bg-gradient-to-br from-emerald-500 via-green-600 to-teal-600 hover:from-emerald-600 hover:via-green-500 hover:to-teal-500 border-2 border-emerald-300/40 shadow-emerald-500/30 hover:shadow-emerald-500/50'
          }
          focus:outline-none focus:ring-4 focus:ring-green-500/40
        `}
                        _focus={{ outlineColor: 'blue.500' }}>
                        <div className="flex items-center gap-2">
                           <svg
                              className="w-4 h-4 transition-transform group-hover:scale-110"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                           </svg>
                           Save And Continue
                        </div>
                     </button>
                  )}

                  {/* Save And Finish Button */}
                  <button
                     onClick={() => onFormSubmit()}
                     ref={savefinishRef}
                     isLoading={isLoadingbt}
                     disabled={isLoadingbt}
                     className={`
        group px-6 py-2.5 font-semibold rounded-xl text-white transition-all duration-300 
        shadow-lg hover:shadow-xl hover:-translate-y-0.5 active:translate-y-0
        disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-md
        ${
           isDark
              ? 'bg-gradient-to-br from-purple-600 via-violet-500 to-fuchsia-600 hover:from-purple-500 hover:via-violet-600 hover:to-fuchsia-500 border-2 border-purple-400/30 shadow-purple-500/30 hover:shadow-purple-400/40'
              : 'bg-gradient-to-br from-purple-500 via-violet-600 to-fuchsia-600 hover:from-purple-600 hover:via-violet-500 hover:to-fuchsia-500 border-2 border-purple-300/40 shadow-purple-500/30 hover:shadow-purple-500/50'
        }
        focus:outline-none focus:ring-4 focus:ring-purple-500/40
      `}
                     _focus={{ outlineColor: 'blue.500' }}>
                     <div className="flex items-center gap-2">
                        <svg
                           className="w-4 h-4 transition-transform group-hover:scale-110"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                        </svg>
                        Save And Finish
                     </div>
                  </button>

                  {/* Cancel Button */}
                  <button
                     variant="ghost"
                     onClick={() => handleOnClose()}
                     className={`
        group px-6 py-2.5 font-semibold rounded-xl border-2 transition-all duration-300 
        hover:shadow-lg hover:-translate-y-0.5 active:translate-y-0
        ${
           isDark
              ? 'text-slate-400 bg-slate-800/50 border-slate-600/50 hover:bg-gradient-to-br hover:from-red-950/40 hover:to-rose-950/40 hover:text-red-400 hover:border-red-500/60 hover:shadow-red-500/20'
              : 'text-slate-600 bg-white border-slate-300/60 hover:bg-gradient-to-br hover:from-red-50 hover:to-rose-50 hover:text-red-700 hover:border-red-400/60 hover:shadow-red-200/40'
        }
        focus:outline-none focus:ring-4 focus:ring-red-500/30
      `}
                     _focus={{ outlineColor: 'blue.500' }}>
                     <div className="flex items-center gap-2">
                        <svg
                           className="w-4 h-4 transition-transform group-hover:rotate-90"
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2.5}
                              d="M6 18L18 6M6 6l12 12"
                           />
                        </svg>
                        Cancel
                     </div>
                  </button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default ItemMasterForm;
